/**
 * BELUGA FITNESS - STOREFRONT ENGINE
 * 
 * 1. Predictive Search & AI Advisor
 * 2. Brand Directory & Brand Navigation Pills
 * 3. PDP Controls, Gallery & Sticky Add-to-Cart Bar
 * 4. Shopify Cart Drawer & Real-Time Sync (/cart.js)
 * 5. Free Shipping Dynamic Threshold Progress Bar
 */

(function() {
  'use strict';

  // ── Asset URL Resolver ───────────────────────────────────────────────────────
  // On Shopify: window.BELUGA_ASSETS is injected by theme.liquid with CDN URLs.
  // On static HTML demo: falls back to relative 'assets/' paths.
  const A = window.BELUGA_ASSETS || {};
  function assetUrl(filename) {
    if (!filename) return 'assets/prod-whey.webp';
    const clean = filename.replace(/^assets\//, '');
    const mapped = {
      'prod-whey.webp':       A.prodWheyWebp      || A.prodWhey      || 'assets/prod-whey.webp',
      'prod-whey.jpg':        A.prodWheyWebp      || A.prodWhey      || 'assets/prod-whey.webp',
      'prod-preworkout.webp': A.prodPreworkoutWebp || A.prodPreworkout || 'assets/prod-preworkout.webp',
      'prod-preworkout.jpg':  A.prodPreworkoutWebp || A.prodPreworkout || 'assets/prod-preworkout.webp',
      'prod-creatine.webp':   A.prodCreatineWebp  || A.prodCreatine  || 'assets/prod-creatine.webp',
      'prod-creatine.jpg':    A.prodCreatineWebp  || A.prodCreatine  || 'assets/prod-creatine.webp',
      'product-hero.webp':    A.productHeroWebp   || A.productHero   || 'assets/product-hero.webp',
      'product-hero.jpg':     A.productHeroWebp   || A.productHero   || 'assets/product-hero.webp',
      'product-bundle.webp':  A.productBundleWebp || A.productBundle || 'assets/product-bundle.webp',
      'product-bundle.jpg':   A.productBundleWebp || A.productBundle || 'assets/product-bundle.webp',
      'beluga-banner.webp':   A.bannerWebp        || A.banner        || 'assets/beluga-banner.webp',
      'beluga-banner.jpg':    A.bannerWebp        || A.banner        || 'assets/beluga-banner.webp',
      'brand-glaxon.jpg':     'assets/brand-glaxon.webp',
      'brand-glaxon.webp':    'assets/brand-glaxon.webp',
    };
    return mapped[clean] || mapped[clean.replace(/\.(jpg|png)$/, '.webp')] || mapped[filename] || filename;
  }

  // Ensure all image URLs are secure, absolute over HTTPS, and optimized in WebP format
  function normalizeImageUrl(url) {
    if (!url) return '';
    let u = String(url).trim();
    if (u.startsWith('//')) u = 'https:' + u;
    if (u.startsWith('http://')) u = u.replace(/^http:\/\//, 'https://');
    if (u.includes('cdn.shopify.com')) {
      if (!u.includes('width=')) u += (u.includes('?') ? '&' : '?') + 'width=360';
      if (!u.includes('format=')) u += '&format=webp';
    }
    return u;
  }

  // Top Featured Brands with Authentic High-Contrast Official Logos
  const TOP_BRANDS = [
    { name: "OPTIMUM NUTRITION", logoFile: "brand-optimum-nutrition.webp" },
    { name: "DYMATIZE NUTRITION", logoFile: "brand-dymatize.png" },
    { name: "MUTANT", logoFile: "brand-mutant.webp" },
    { name: "GHOST", logoFile: "brand-ghost.png" },
    { name: "RYSE", logoFile: "brand-ryse.svg" },
    { name: "RAW", logoFile: "brand-raw.svg" },
    { name: "INSANE LABZ", logoFile: "brand-insane-labz.webp" },
    { name: "DRAGON PHARMA", logoFile: "brand-dragon-pharma.webp" },
    { name: "CELLUCOR", logoFile: "brand-cellucor.webp" },
    { name: "MUSCLETECH", logoFile: "brand-muscletech.png" },
    { name: "REDCON1", logoFile: "brand-redcon1.svg" },
    { name: "EVOGEN NUTRITION", logoFile: "brand-evogen.webp" },
    { name: "GAT SPORT", logoFile: "brand-gat-sport.webp" },
    { name: "UNIVERSAL NUTRITION", logoFile: "brand-universal.png" },
    { name: "ANIMAL", logoFile: "brand-animal.webp" },
    { name: "BSN", logoFile: "brand-bsn.svg" },
    { name: "LABRADA", logoFile: "brand-labrada.webp" },
    { name: "BETANCOURT NUTRITION", logoFile: "brand-betancourt.webp" },
    { name: "RULE 1", logoFile: "brand-rule1.svg" },
    { name: "MUSCLE PHARM", logoFile: "brand-musclepharm.webp" },
    { name: "ALLMAX", logoFile: "brand-allmax.webp" },
    { name: "BPI", logoFile: "brand-bpi.svg" },
    { name: "NUTREX", logoFile: "brand-nutrex.svg" },
    { name: "GLAXON", logoFile: "brand-glaxon.jpg" },
    { name: "BIRDMAN", logoFile: "brand-birdman.svg" }
  ];

  // Full Brand Catalog
  const BRANDS = {
    principales: [
      "ALLMAX", "ARMADA", "BETANCOURT NUTRITION", "BIRDMAN", "BPI", "BSN", "CELLUCOR",
      "CLOMA PHARMA", "COBRA LABS", "DIABLO POWER", "DRAGON PHARMA", "DYMATIZE NUTRITION",
      "ESSENTIALS", "EVL NUTRITION", "EVOGEN NUTRITION", "FINAFLEX", "GASPARI NUTRITION",
      "GAT SPORT", "GHOST", "GLAXON", "HIGH TECH PHARMACEUTICALS", "INSANE LABZ",
      "LABRADA", "LENNY & LARRYS", "META NUTRITION", "MUSCLE PHARM", "MUSCLEMEDS",
      "MUSCLETECH", "MUTANT", "NATURES BEST", "NUBREED", "NUTREX", "OPTIMUM NUTRITION",
      "PHYSICAL BUILDING SYSTEMS", "RAW", "REDCON1", "RYSE", "SCIVATION", "SYNTRAX",
      "ULTIMATE SPORT NUTRITION", "UNIVERSAL NUTRITION", "WINDMILL HEALTH PRODUCTS"
    ],
    otras: [
      "4 LIMITS", "43 SUPLEMENTS", "ADVANCE NUTRITION", "ALPHA NUTRITION",
      "ANS PERFORMANCE", "ARIANA JAMES", "BAG BULL FITNESS LIFE", "BARBARIAN RESEARCH",
      "BHN", "BHP", "BIOPHARMA", "BITECH SUPLEMENTS", "BLACKSTAR", "BOULDER ROIDS",
      "BRITISH DISPENSARY", "BUCKED UP", "BULLPHARMA", "CAFETALERA ALIANZA", "CYTOGENYX",
      "DYNAMIC DEVELOPMENT", "ELITE LABS", "EURO LAB", "EVOLUTION NUTRACEUTICAL",
      "FERRING", "FIBO", "FITMISS", "FORMUTECH", "FORZAGEN", "GEAR", "GENLI PHARMA",
      "GERMAN LABS", "HYSTERICAL SCIENCE LABS", "INDUFAR", "INNER ARMOUR BLACK",
      "INNOVA LABS", "INNOVATIVE LABORATORIES", "JAY CUTLER", "KILLER LABS",
      "LAGUNA TRANDING", "LEGENDARY", "MAN SPORTS", "MDN LABS", "MESO 10",
      "MESOFRANCE", "MHP", "MYOGENIX", "MYTHICAL NUTRITION", "NANO SPORT TECHNOLOGIES",
      "NUTRIFITT", "OMEGA LAB", "PANDA", "PERFECT MUSCLE NUTRITION", "PLAYERAS",
      "PRIMAFORCE", "PRIME PHARMACEUTICALS", "PROTAN", "PUBLICIDAD", "PURELY INSPIRED",
      "PURO CAMPEON", "RED GOLD", "REVITAL ORMONE", "RONNIE COLEMAN", "RSP",
      "SAIYAN LABZ", "SAN NUTRITION", "SCHERING-PLOUGH", "SCI LABS", "SCULPT",
      "SHAKER", "SLMF", "SMART", "SMARTSHAKE", "SPARTAN", "STARKE", "TERROR LABS",
      "THE ASYLUM CABINET", "TOP SECRET NUTRITION", "USPLABS", "VASSAL PHARMACEUTICAL", "VICTORY"
    ]
  };

  // ── Directorio de marcas: solo lo que la tienda vende de verdad ──────────────
  // Las dos listas de arriba se escribieron a mano y arrastraban ~50 marcas sin un
  // solo producto publicado (ANIMAL, RULE 1, MUSCLE PHARM, GLAXON, SCHERING-PLOUGH...).
  // Cada una abria /collections/vendors?q=... completamente vacio desde el modal
  // "Marcas (+100)", que es la navegacion principal del header.
  // `window.BELUGA_STORE_VENDORS` lo emite layout/theme.liquid con los vendors reales
  // del catalogo; si por lo que sea no llega, se deja la lista escrita a mano intacta.
  (function reconcileBrandDirectory() {
    const realVendors = Array.isArray(window.BELUGA_STORE_VENDORS) ? window.BELUGA_STORE_VENDORS : [];
    if (realVendors.length === 0) return;

    const canonicalByKey = new Map();
    realVendors.forEach(v => {
      const name = String(v || '').trim();
      if (name) canonicalByKey.set(name.toUpperCase(), name);
    });
    const isReal = name => canonicalByKey.has(String(name || '').trim().toUpperCase());

    for (let i = TOP_BRANDS.length - 1; i >= 0; i--) {
      if (!isReal(TOP_BRANDS[i].name)) TOP_BRANDS.splice(i, 1);
    }

    const alreadyListed = new Set();
    ['principales', 'otras'].forEach(key => {
      BRANDS[key] = BRANDS[key].filter(name => {
        if (!isReal(name)) return false;
        alreadyListed.add(String(name).trim().toUpperCase());
        return true;
      });
    });

    // Marcas que si estan en el catalogo pero faltaban en la lista escrita a mano.
    const missing = [];
    canonicalByKey.forEach((name, key) => {
      if (!alreadyListed.has(key)) missing.push(name);
    });
    BRANDS.otras = BRANDS.otras.concat(missing).sort((a, b) => a.localeCompare(b, 'es'));
  })();

  // Smart Quality & Premium Brand Tier Ranking for Store Catalog
  function sortProductsByQuality(products) {
    if (!Array.isArray(products)) return [];

    function getQualityScore(p) {
      const title = (p.name || p.title || '').toLowerCase();
      const vendor = (p.brand || p.vendor || '').toLowerCase();
      let score = 0;

      // Tier 1: Top Quality American & Global Flagship Brands (Dymatize, RAW, Ghost, Isopure, Birdman, ON, Ryse, ALLMAX)
      if (vendor.includes('dymatize') || title.includes('iso 100') || title.includes('dymatize')) score += 150;
      if (vendor.includes('isopure') || title.includes('isopure')) score += 145;
      if (vendor.includes('optimum') || title.includes('gold standard')) score += 140;
      if (vendor.includes('raw') || title.includes('cbum') || title.includes('thavage')) score += 135;
      if (vendor.includes('ghost')) score += 130;
      if (vendor.includes('birdman') || title.includes('falcon protein')) score += 125;
      if (vendor.includes('ryse') || title.includes('godzilla')) score += 120;
      if (vendor.includes('allmax') || title.includes('isoflex')) score += 115;
      if (vendor.includes('cellucor') || title.includes('c4')) score += 110;
      if (vendor.includes('universal') || vendor.includes('animal') || title.includes('animal pak')) score += 105;
      if (vendor.includes('muscletech') || title.includes('nitro-tech')) score += 100;
      if (vendor.includes('mutant') || title.includes('mutant mass')) score += 95;
      if (vendor.includes('bsn') || title.includes('syntha-6')) score += 90;
      if (vendor.includes('insane labz') || title.includes('psychotic')) score += 85;
      if (vendor.includes('redcon1') || title.includes('total war')) score += 80;

      // Product Type Bonus (Isolates, Creapure/Creatines, High-Stim Pre-Workouts)
      if (title.includes('isolate') || title.includes('aislada') || title.includes('hydrolyzed') || title.includes('hidrolizada')) score += 20;
      if (title.includes('creapure') || title.includes('creatina') || title.includes('creatine')) score += 15;
      if (title.includes('pre-workout') || title.includes('pre-entreno')) score += 10;

      // Price / Formulation Value factor
      const price = typeof p.price === 'number' ? p.price : (parseFloat(String(p.price).replace(/[^0-9.]/g, '')) || 0);
      score += (price / 100);

      return score;
    }

    return [...products].sort((a, b) => getQualityScore(b) - getQualityScore(a));
  }

  // Shuffle array randomly (Fisher-Yates) for random inventory showcase
  function shuffleProducts(arr) {
    if (!Array.isArray(arr) || arr.length === 0) return [];
    const shuffled = [...arr];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  }

  // Dynamic Store Catalog Resolver: ONLY real inventory products, randomized on load
  function getCatalogProducts() {
    const storeProds = window.BELUGA_STORE_PRODUCTS;
    if (Array.isArray(storeProds) && storeProds.length > 0) {
      return shuffleProducts(storeProds);
    }
    return [];
  }

  // Dynamic PRODUCTS proxy (ensures all existing references read real store products)
  const PRODUCTS = new Proxy([], {
    get(target, prop) {
      const prods = getCatalogProducts();
      if (typeof prods[prop] === 'function') {
        return prods[prop].bind(prods);
      }
      return prods[prop];
    }
  });

  // Cart State (Persisted)
  let cart = JSON.parse(localStorage.getItem('beluga_cart') || '[]');
  // Un solo umbral para toda la tienda (definido en settings de Shopify o fallback a 1499).
  const FREE_SHIPPING_THRESHOLD = Number(
    (window.BELUGA_SHOP && window.BELUGA_SHOP.freeShippingThreshold) || 1499
  ); // MXN

  // DOM Elements
  const searchInput = document.getElementById('main-search-input') || document.getElementById('search-input');
  const searchDropdown = document.getElementById('search-dropdown');
  const searchResultsContainer = document.getElementById('search-results-list');
  const productsGrid = document.getElementById('products-grid');
  const btnClearSearch = document.getElementById('btn-clear-search');
  const resultsCountLabel = document.getElementById('results-count-label');
  const brandsModalOverlay = document.getElementById('brands-modal-overlay');
  const brandsModalTrigger = document.getElementById('btn-open-brands-modal');
  const closeBrandsModalBtn = document.getElementById('btn-close-brands-modal');
  const brandsModalSearch = document.getElementById('brands-modal-search');
  const btnClearBrandsSearch = document.getElementById('btn-clear-brands-search');
  const brandsAzStrip = document.getElementById('brands-az-strip');
  const brandsTopGrid = document.getElementById('brands-top-grid');
  const brandsAllGrid = document.getElementById('brands-all-grid');
  const brandsFeaturedSection = document.getElementById('brands-featured-section');
  const brandsEmptyState = document.getElementById('brands-empty-state');
  const brandPillContainer = document.getElementById('brand-pills-bar');
  
  // Cart Drawer Elements
  const cartDrawerOverlay = document.getElementById('cart-drawer-overlay');
  const cartTriggerBtn = document.getElementById('btn-cart-toggle');
  const closeCartBtn = document.getElementById('btn-close-cart');
  const cartItemsContainer = document.getElementById('cart-drawer-items');
  const cartSubtotalElem = document.getElementById('cart-subtotal-val');
  const cartSavingsElem = document.getElementById('cart-savings-val');
  const cartBadgeElem = document.getElementById('cart-badge');
  const shippingBarFill = document.getElementById('shipping-bar-fill');
  const shippingText = document.getElementById('shipping-text');
  const cartTimerElem = document.getElementById('cart-timer-digits');

  // PDP Elements
  const pdpMainImg = document.getElementById('pdp-main-img');
  const pdpThumbs = document.querySelectorAll('.pdp-thumb-item');
  const btnPdpAddToCart = document.getElementById('btn-pdp-add-to-cart');
  const stickyPdpBar = document.getElementById('sticky-pdp-bar');

  // Un paso que revienta no puede dejar sin montar a los que vienen detras. init() era una
  // cadena recta y el primer error se llevaba por delante todo lo demas: el menu de orden
  // del catalogo, que estaba a media fila, se quedaba sin enganchar por un fallo del buscador
  // o de las pastillas de marca, y el sintoma que veia el comprador era una tienda muda.
  function safely(label, fn) {
    try {
      return fn();
    } catch (err) {
      console.error(`[Beluga] ${label} fallo:`, err);
    }
  }

  // Initialize
  async function init() {
    safely('renderBrandPills', renderBrandPills);
    safely('renderBrandsModal', renderBrandsModal);
    // Populate productsGrid with real products if server didn't pre-render cards
    safely('renderProducts', () => {
      if (productsGrid && !productsGrid.querySelector('.apple-product-card')) {
        const realProds = getCatalogProducts();
        if (realProds && realProds.length > 0) {
          renderProducts(realProds);
        }
      }
    });
    safely('setupPredictiveSearch', setupPredictiveSearch);
    safely('setupCategoryFiltering', setupCategoryFiltering);
    safely('setupBrandCollectionShowcase', setupBrandCollectionShowcase);
    safely('setupCartDrawer', setupCartDrawer);
    safely('setupPDPControls', setupPDPControls);
    safely('startCartUrgencyTimer', startCartUrgencyTimer);
    try {
      await syncCartWithShopify();
    } catch (err) {
      console.error('[Beluga] syncCartWithShopify fallo:', err);
    }
    if (window.location.pathname.includes('checkout')) {
      const subtotal = cart.reduce((s, i) => s + i.price * i.quantity, 0);
      BelugaAnalytics.track('begin_checkout', { value: subtotal, cart });
    }
    updateCartUI();
  }

  // Helper to get monogram for brand
  function getMonogram(name) {
    if (!name) return 'BF';
    const words = name.replace(/[^A-Za-z0-9\s]/g, '').trim().split(/\s+/);
    if (words.length >= 2) {
      return (words[0][0] + words[1][0]).toUpperCase();
    }
    return name.slice(0, 2).toUpperCase();
  }

  // Helper to check if brand has an official original logo and return its render object
  function getBrandLogo(name) {
    const norm = (name || '').toUpperCase().trim();
    if (!norm) return null;
    const L = window.BELUGA_BRAND_LOGOS || {};
    if (L[norm]) return { type: 'img', src: L[norm] };

    // Fuzzy matching for variations
    for (const [k, v] of Object.entries(L)) {
      if (norm === k || norm.startsWith(k) || k.startsWith(norm) || norm.includes(k) || k.includes(norm)) {
        return { type: 'img', src: v };
      }
    }

    const found = TOP_BRANDS.find(tb => {
      const tbNorm = tb.name.toUpperCase();
      return tbNorm === norm || norm.startsWith(tbNorm) || tbNorm.startsWith(norm) || norm.includes(tbNorm) || tbNorm.includes(norm);
    });
    if (found) {
      if (found.svg) return { type: 'svg', content: found.svg };
      if (found.logoUrl) return { type: 'img', src: found.logoUrl };
      if (found.logoFile) return { type: 'img', src: `assets/${found.logoFile}` };
    }
    return null;
  }

  // 1. Render Brand Quick Bar Pills
  function renderBrandPills() {
    if (!brandPillContainer) return;
    const topBrands = ["TODAS", ...BRANDS.principales.slice(0, 16)];
    brandPillContainer.innerHTML = topBrands.map((brand, idx) => `
      <button class="brand-pill-btn ${idx === 0 ? 'active' : ''}" data-brand="${brand}">
        ${brand}
      </button>
    `).join('');

    brandPillContainer.querySelectorAll('.brand-pill-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        brandPillContainer.querySelectorAll('.brand-pill-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        const selectedBrand = btn.dataset.brand;
        const catalog = getCatalogProducts();
        if (selectedBrand === 'TODAS') {
          renderProducts(catalog);
        } else {
          const filtered = catalog.filter(p => (p.brand || p.vendor || '').toUpperCase().includes(selectedBrand.toUpperCase()));
          renderProducts(filtered);
        }
      });
    });
  }

  // 2. Render Brands Directory Showcase Modal (Apple Glass Experience)
  function renderBrandsModal() {
    if (!brandsModalOverlay) return;

    const storeVendors = Array.isArray(window.BELUGA_STORE_PRODUCTS) && window.BELUGA_STORE_PRODUCTS.length > 0
      ? window.BELUGA_STORE_PRODUCTS.map(p => (p.vendor || p.brand || '').trim()).filter(v => v.length > 0)
      : [];

    const allBrandsList = Array.from(new Set([
      ...TOP_BRANDS.map(b => b.name),
      ...BRANDS.principales,
      ...BRANDS.otras,
      ...storeVendors
    ])).sort((a, b) => a.localeCompare(b, 'es'));

    // Extract unique letters A-Z for the index strip
    const letters = Array.from(new Set(
      allBrandsList.map(b => {
        const firstChar = b.trim().charAt(0).toUpperCase();
        return /^[A-Z]$/.test(firstChar) ? firstChar : '#';
      })
    )).sort((a, b) => (a === '#' ? 1 : b === '#' ? -1 : a.localeCompare(b)));

    // Render A-Z Navigation Strip
    if (brandsAzStrip) {
      brandsAzStrip.innerHTML = `
        <button type="button" class="apple-az-chip active" data-letter="ALL">TODOS</button>
        <button type="button" class="apple-az-chip" data-letter="TOP">⭐ TOP</button>
        ${letters.map(l => `<button type="button" class="apple-az-chip" data-letter="${l}">${l}</button>`).join('')}
      `;

      brandsAzStrip.querySelectorAll('.apple-az-chip').forEach(chip => {
        chip.addEventListener('click', () => {
          brandsAzStrip.querySelectorAll('.apple-az-chip').forEach(c => c.classList.remove('active'));
          chip.classList.add('active');
          const letter = chip.dataset.letter;

          if (brandsModalSearch) {
            brandsModalSearch.value = '';
            if (btnClearBrandsSearch) btnClearBrandsSearch.style.display = 'none';
          }

          if (letter === 'ALL') {
            if (brandsFeaturedSection) brandsFeaturedSection.style.display = 'block';
            populateDirectory('');
            const scrollArea = document.querySelector('.apple-brands-scroll-area');
            if (scrollArea) scrollArea.scrollTo({ top: 0, behavior: 'smooth' });
          } else if (letter === 'TOP') {
            if (brandsFeaturedSection) brandsFeaturedSection.style.display = 'block';
            populateDirectory('', 'TOP');
            const scrollArea = document.querySelector('.apple-brands-scroll-area');
            if (scrollArea) scrollArea.scrollTo({ top: 0, behavior: 'smooth' });
          } else {
            if (brandsFeaturedSection) brandsFeaturedSection.style.display = 'none';
            populateDirectory('', letter);
            const targetGroup = document.getElementById(`brand-group-${letter}`);
            if (targetGroup) {
              targetGroup.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }
        });
      });
    }

    function populateDirectory(filterText = '', targetLetter = '') {
      const q = filterText.toLowerCase().trim();

      // 1. Populate Top Brands Grid with Original Official Logos
      if (brandsTopGrid && brandsFeaturedSection) {
        const filteredTop = TOP_BRANDS.filter(tb => {
          const matchQuery = !q || tb.name.toLowerCase().includes(q) || (tb.tag && tb.tag.toLowerCase().includes(q));
          const matchLetter = !targetLetter || targetLetter === 'TOP' || tb.name.toUpperCase().startsWith(targetLetter);
          return matchQuery && (targetLetter === 'TOP' ? true : matchLetter);
        });

        if (filteredTop.length === 0 || (targetLetter && targetLetter !== 'TOP' && targetLetter !== 'ALL')) {
          brandsFeaturedSection.style.display = 'none';
        } else {
          brandsFeaturedSection.style.display = 'block';
          brandsTopGrid.innerHTML = filteredTop.map(tb => {
            const logo = getBrandLogo(tb.name);
            let logoHtml = '';
            if (logo && logo.type === 'svg') {
              logoHtml = logo.content;
            } else if (logo && logo.type === 'img') {
              logoHtml = `<img src="${logo.src}" alt="${escapeHtml(tb.name)} Logo Oficial" class="apple-brand-top-logo" loading="lazy" width="120" height="48" onerror="this.onerror=null; this.style.display='none'; this.nextElementSibling && (this.nextElementSibling.style.display='flex')"><div class="apple-brand-monogram" style="display:none">${getMonogram(tb.name)}</div>`;
            } else {
              logoHtml = `<div class="apple-brand-monogram">${getMonogram(tb.name)}</div>`;
            }

            return `
              <a href="/collections/vendors?q=${encodeURIComponent(tb.name)}" class="apple-brand-card-top" data-brand="${escapeHtml(tb.name)}" title="Ver catálogo oficial de ${escapeHtml(tb.name)}">
                <div class="apple-brand-top-logo-wrap">
                  ${logoHtml}
                </div>
                <div class="apple-brand-top-name">${escapeHtml(tb.name)}</div>
              </a>
            `;
          }).join('');
        }
      }

      // 2. Populate All Brands A-Z Grid
      if (brandsAllGrid) {
        let filteredAll = allBrandsList.filter(b => {
          const matchQuery = !q || b.toLowerCase().includes(q);
          const firstChar = b.trim().charAt(0).toUpperCase();
          const brandLetter = /^[A-Z]$/.test(firstChar) ? firstChar : '#';
          const matchLetter = !targetLetter || targetLetter === 'ALL' || targetLetter === 'TOP' || brandLetter === targetLetter;
          return matchQuery && matchLetter;
        });

        const hasTopMatches = brandsTopGrid && brandsTopGrid.children.length > 0 && brandsFeaturedSection && brandsFeaturedSection.style.display !== 'none';

        if (filteredAll.length === 0 && !hasTopMatches) {
          if (brandsEmptyState) brandsEmptyState.style.display = 'block';
          brandsAllGrid.innerHTML = '';
        } else {
          if (brandsEmptyState) brandsEmptyState.style.display = 'none';

          // Group by letter
          const grouped = {};
          filteredAll.forEach(b => {
            const firstChar = b.trim().charAt(0).toUpperCase();
            const letter = /^[A-Z]$/.test(firstChar) ? firstChar : '#';
            if (!grouped[letter]) grouped[letter] = [];
            grouped[letter].push(b);
          });

          const sortedLetters = Object.keys(grouped).sort((a, b) => (a === '#' ? 1 : b === '#' ? -1 : a.localeCompare(b)));

          brandsAllGrid.innerHTML = sortedLetters.map(letter => `
            <div class="apple-brand-group" id="brand-group-${letter}">
              <div class="apple-brand-group-letter">
                <span>Letra ${letter}</span>
                <span class="apple-brand-group-count">${grouped[letter].length} marca${grouped[letter].length !== 1 ? 's' : ''}</span>
              </div>
              <div class="apple-brand-group-items">
                ${grouped[letter].map(brandName => {
                  const logo = getBrandLogo(brandName);
                  let logoHtml = '';
                  if (logo && logo.type === 'svg') {
                    logoHtml = `<div style="width: 28px; height: 28px; display: flex; align-items: center; justify-content: center; flex-shrink: 0;">${logo.content}</div>`;
                  } else if (logo && logo.type === 'img') {
                    logoHtml = `<img src="${logo.src}" alt="${escapeHtml(brandName)}" class="apple-brand-mini-logo" loading="lazy" width="28" height="28" onerror="this.style.display='none'; this.nextElementSibling ? this.nextElementSibling.style.display='flex' : null;"><div class="apple-brand-monogram" style="display:none;">${getMonogram(brandName)}</div>`;
                  } else {
                    logoHtml = `<div class="apple-brand-monogram">${getMonogram(brandName)}</div>`;
                  }

                  return `
                    <a href="/collections/vendors?q=${encodeURIComponent(brandName)}" class="apple-brand-row-item" data-brand="${escapeHtml(brandName)}" title="Ver productos de ${escapeHtml(brandName)}">
                      ${logoHtml}
                      <span style="flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${escapeHtml(brandName)}</span>
                      <span style="font-size: 11px; color: var(--apple-text-secondary); opacity: 0.7;">→</span>
                    </a>
                  `;
                }).join('')}
              </div>
            </div>
          `).join('');
        }
      }

      // Attach click listeners for instant collection redirection & analytics tracking
      document.querySelectorAll('.apple-brand-card-top, .apple-brand-row-item').forEach(item => {
        item.addEventListener('click', (e) => {
          const b = item.dataset.brand;
          BelugaAnalytics.track('brand_clicked', { brand: b });
          
          // If on standalone HTML demo file (file:///), filter in-page catalog
          if (window.location.protocol === 'file:') {
            e.preventDefault();
            closeBrandsModal();
            if (searchInput) searchInput.value = b;
            if (btnClearSearch) btnClearSearch.style.display = 'inline-flex';
            filterCatalogByBrandOrQuery(b);
          }
          // On live store / Shopify dev, let the link navigate naturally to /collections/vendors?q=...
        });
      });
    }

    populateDirectory();

    // Live search input in modal
    if (brandsModalSearch) {
      let brandsSearchTimer = null;
      brandsModalSearch.addEventListener('input', (e) => {
        clearTimeout(brandsSearchTimer);
        const val = e.target.value;
        if (btnClearBrandsSearch) {
          btnClearBrandsSearch.style.display = val.length > 0 ? 'inline-flex' : 'none';
        }
        brandsSearchTimer = setTimeout(() => {
          populateDirectory(val);
        }, 150);
      });
    }

    if (btnClearBrandsSearch) {
      btnClearBrandsSearch.addEventListener('click', () => {
        if (brandsModalSearch) {
          brandsModalSearch.value = '';
          brandsModalSearch.focus();
        }
        btnClearBrandsSearch.style.display = 'none';
        populateDirectory('');
      });
    }

    if (brandsModalTrigger) brandsModalTrigger.addEventListener('click', openBrandsModal);

    // Chip "Ver las +100" del hero: abre el mismo directorio de marcas del header.
    const btnOpenBrandsHero = document.getElementById('btn-open-brands-modal-hero');
    if (btnOpenBrandsHero) {
      btnOpenBrandsHero.addEventListener('click', (e) => {
        e.preventDefault();
        openBrandsModal();
      });
    }
    if (closeBrandsModalBtn) closeBrandsModalBtn.addEventListener('click', closeBrandsModal);
    if (brandsModalOverlay) {
      brandsModalOverlay.addEventListener('click', (e) => {
        if (e.target === brandsModalOverlay) closeBrandsModal();
      });
    }
  }

  function openBrandsModal() {
    if (brandsModalOverlay) {
      brandsModalOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
      if (brandsModalSearch) {
        setTimeout(() => brandsModalSearch.focus(), 150);
      }
    }
  }

  function closeBrandsModal() {
    if (brandsModalOverlay) {
      brandsModalOverlay.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  // Setup Brand Collection Showcase Hero & Dynamic Subfilters
  function setupBrandCollectionShowcase() {
    // 1. Populate Brand Hero Logo
    const heroLogoContainer = document.getElementById('brand-hero-logo-container');
    if (heroLogoContainer) {
      const brandName = heroLogoContainer.dataset.brandName || '';
      const norm = brandName.toUpperCase().trim();
      const L = window.BELUGA_BRAND_LOGOS || {};
      const logo = getBrandLogo(norm);

      if (logo && logo.type === 'svg') {
        heroLogoContainer.innerHTML = logo.content;
      } else if (logo && logo.type === 'img') {
        heroLogoContainer.innerHTML = `<img src="${logo.src}" alt="${brandName} Logo Oficial" width="120" height="70" loading="eager" style="max-height: 70px; object-fit: contain;">`;
      } else if (L[norm]) {
        heroLogoContainer.innerHTML = `<img src="${L[norm]}" alt="${brandName} Logo Oficial" width="120" height="70" loading="eager" style="max-height: 70px; object-fit: contain;">`;
      }
    }

    // 2. Breadcrumb trigger for brands modal
    const breadcrumbBrands = document.getElementById('breadcrumb-open-brands');
    if (breadcrumbBrands) {
      breadcrumbBrands.addEventListener('click', (e) => {
        e.preventDefault();
        openBrandsModal();
      });
    }

    // 3. Los chips de categoria ahora son enlaces a listados reales (snippets/category-nav.liquid).
    //    Antes escondian tarjetas de la pagina visible por coincidencia de titulo: con 24 de
    //    2,096 productos, Pre-Entreno y Aminoacidos siempre caian en el estado vacio.

    // 4. Menu de orden de la coleccion (sections/main-collection.liquid)
    //
    // El orden ya NO depende de este archivo: el menu es un <details> con un <a> por
    // opcion, cada uno con su ?sort_by= ya construido en Liquid, asi que abre y aplica al
    // primer clic aunque el JS no haya cargado. Antes era un <select> con un listener de
    // `change` montado aqui dentro, al final de la cadena de init(): si algo fallaba antes
    // — o si el navegador no disparaba `change` — el comprador elegia "Menor Precio" y la
    // pagina se quedaba quieta. Lo unico que queda aqui son los cierres que el navegador no
    // da gratis: clic fuera y tecla Escape.
    const sortMenu = document.querySelector('[data-sort-menu]');
    if (sortMenu) {
      document.addEventListener('click', (e) => {
        if (sortMenu.open && !sortMenu.contains(e.target)) sortMenu.open = false;
      });
      sortMenu.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape' || !sortMenu.open) return;
        sortMenu.open = false;
        const trigger = sortMenu.querySelector('summary');
        if (trigger) trigger.focus();
      });
    }
  }

  // 3. Render Product Cards Grid (Apple HIG Squircles)
  function renderProducts(productList) {
    if (!productsGrid) return;

    if (resultsCountLabel) {
      resultsCountLabel.textContent = `${productList.length} producto${productList.length === 1 ? '' : 's'}`;
    }

    if (!productList || productList.length === 0) {
      productsGrid.innerHTML = `
        <div style="grid-column: 1 / -1; padding: 48px 0; text-align: center; color: var(--apple-text-secondary);">
          <p style="font-size: 16px; margin-bottom: 8px;">No se encontraron productos coincidentes.</p>
          <button class="apple-secondary-btn" style="margin-top: 12px; font-size: 13px; padding: 8px 20px;" onclick="window.location.reload()">Ver Todos los Productos</button>
        </div>
      `;
      return;
    }

    productsGrid.innerHTML = productList.map((prod, idx) => {
      const imgUrl = normalizeImageUrl(prod.image);
      const isAboveFold = idx < 8;
      return `
      <article class="apple-product-card" data-category="${((prod.type || prod.category) || '').toLowerCase()}" data-brand="${prod.brand || prod.vendor || ''}">
        <a href="${prod.url || '#'}" class="apple-card-img-wrap" aria-label="${(prod.name || prod.title || '').replace(/"/g, '&quot;')}">
          ${prod.originalPrice > prod.price ? `<span class="apple-card-badge">OFERTA FLASH</span>` : ''}
          ${imgUrl ? `
            <img 
              src="${imgUrl}" 
              alt="${(prod.name || prod.title || '').replace(/"/g, '&quot;')}" 
              loading="${isAboveFold ? 'eager' : 'lazy'}" 
              ${isAboveFold ? 'fetchpriority="high"' : ''}
              decoding="async" 
              width="360" 
              height="360" 
              class="apple-card-img is-loaded"
              onerror="if (!this.dataset.fallback) { this.dataset.fallback='1'; if (this.src.includes('.webp')) { this.src=this.src.replace('.webp','.jpg'); } else { this.src='data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%22480%22 height=%22480%22 viewBox=%220 0 480 480%22%3E%3Crect width=%22480%22 height=%22480%22 fill=%22%23F5F5F7%22/%3E%3Ctext x=%22240%22 y=%22240%22 text-anchor=%22middle%22 dominant-baseline=%22middle%22 font-family=%22system-ui%22 font-size=%2240%22 fill=%22%23AEAEB2%22%3E🏋️%3C/text%3E%3C/svg%3E'; } }"
            >
          ` : `
            <div class="apple-card-img-placeholder" style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;background:#F5F5F7;font-size:48px;border-radius:12px;">
              🏋️
            </div>
          `}
        </a>

        <div class="apple-card-body">
          <div class="apple-card-brand">${(prod.brand || prod.vendor || 'BELUGA FITNESS').toUpperCase()}</div>
          <h3 class="apple-card-title">
            <a href="${prod.url || '#'}">${prod.name || prod.title}</a>
          </h3>

          <div class="apple-card-footer">
            <div class="apple-card-price-block">
              <span class="apple-price-current tabular-nums">$${parseFloat(prod.price || 0).toLocaleString('es-MX', { minimumFractionDigits: 2 })} MXN</span>
              ${prod.originalPrice > prod.price ? `<span class="apple-price-original tabular-nums">$${parseFloat(prod.originalPrice).toLocaleString('es-MX', { minimumFractionDigits: 2 })}</span>` : ''}
            </div>

            <button 
              class="btn-apple-add btn-card-add-cart" 
              data-id="${prod.variantId || ''}" 
              data-variant-id="${prod.variantId || ''}"
              data-handle="${prod.handle || ''}"
              data-url="${prod.url || ''}"
              data-title="${(prod.name || prod.title || '').replace(/"/g, '&quot;')}"
              data-price="${prod.price}"
              data-original-price="${prod.originalPrice || prod.price}"
              data-brand="${(prod.brand || prod.vendor || '').replace(/"/g, '&quot;')}"
              data-image="${prod.image || ''}"
              type="button"
              ${prod.available === false ? 'disabled style="opacity: 0.5; cursor: not-allowed;"' : ''}
            >
              ${prod.available === false ? 'Agotado' : '+ Añadir'}
            </button>
          </div>
        </div>
      </article>
      `;
    }).join('');
  }

  // 4. Native Shopify & OpenRouter AI Predictive Search Engine
  function setupPredictiveSearch() {
    if (!searchInput) return;

    let debounceTimer = null;
    let currentQuery = '';
    let lastExecutedQuery = '';
    const aiQueryCache = new Map();
    // AI Mode is OFF by default (in gray); user clicks to turn ON (lights up bar & button)
    let isAiModeEnabled = localStorage.getItem('beluga_ai_mode') === 'on';
    // SEGURIDAD: sin fallback hardcodeado. Una API key en JS del storefront es publica.
    // Si no hay key configurada en el theme editor, el modo IA queda desactivado y
    // el buscador usa la busqueda nativa de Shopify (que igual funciona bien).
    const OPENROUTER_API_KEY = (window.BELUGA_AI_CONFIG && window.BELUGA_AI_CONFIG.openrouterApiKey) || '';
    // Una key en blanco o el placeholder dummy que queda en settings_data.json no sirven
    // para llamar a OpenRouter. Sin esto se dispara una peticion condenada al 401 en cada
    // consulta: el fallback local igual respondia, pero pagando un viaje de red inutil.
    function hasUsableAiKey() {
      const k = String(OPENROUTER_API_KEY || '').trim();
      // Las keys de OpenRouter son de ~73 caracteres; 20 es un piso holgado que descarta
      // placeholders ("sk-or-v1-...") sin arriesgarse a bloquear una key legitima.
      return k.length >= 20 && !/dummy|reemplazar|pega[- ]?aqui|tu[- ]?key/i.test(k);
    }

    // AI Mode Toggle Button & Glowing Spotlight Bar handler
    const btnToggleAi = document.getElementById('btn-toggle-ai-mode');
    function updateAiToggleUI() {
      const spotlightBar = document.getElementById('apple-spotlight-bar');
      if (btnToggleAi) {
        if (isAiModeEnabled) {
          btnToggleAi.classList.add('active');
          btnToggleAi.classList.remove('disabled');
          btnToggleAi.setAttribute('aria-pressed', 'true');
          btnToggleAi.setAttribute('title', 'Asesor IA Encendido — Haz clic para apagar');
          btnToggleAi.innerHTML = '<span class="ai-toggle-sparkle" style="font-size: 11px;">✦</span> <span class="ai-toggle-label">IA</span>';
        } else {
          btnToggleAi.classList.remove('active');
          btnToggleAi.classList.add('disabled');
          btnToggleAi.setAttribute('aria-pressed', 'false');
          btnToggleAi.setAttribute('title', 'Asesor IA Apagado — Haz clic para encender');
          btnToggleAi.innerHTML = '<span class="ai-toggle-sparkle" style="font-size: 11px;">✦</span> <span class="ai-toggle-label">IA</span>';
        }
      }
      if (spotlightBar) {
        if (isAiModeEnabled) {
          spotlightBar.classList.add('ai-mode-on');
        } else {
          spotlightBar.classList.remove('ai-mode-on');
        }
      }
    }

    if (btnToggleAi) {
      updateAiToggleUI();
      btnToggleAi.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        isAiModeEnabled = !isAiModeEnabled;
        localStorage.setItem('beluga_ai_mode', isAiModeEnabled ? 'on' : 'off');
        updateAiToggleUI();
        lastExecutedQuery = ''; // Reset so active search re-evaluates immediately
        if (searchInput && searchInput.value.trim().length > 0) {
          handleSearchInput();
        }
      });
    }

    function escapeHtml(str) {
      return (str || '').replace(/[&<>"']/g, m => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      })[m]);
    }

    function safeJsonParse(rawText) {
      if (!rawText || typeof rawText !== 'string') return null;
      const clean = rawText.trim();
      try {
        return JSON.parse(clean);
      } catch (e) {
        const match = clean.match(/```(?:json)?\s*([\s\S]*?)\s*```/) || clean.match(/\{[\s\S]*\}/);
        if (match) {
          try {
            return JSON.parse(match[1] || match[0]);
          } catch (e2) {
            return null;
          }
        }
      }
      return null;
    }

    function resolveProductImageUrl(p) {
      let img = p.featured_image?.url || p.image || p.featured_image || (Array.isArray(p.images) ? p.images[0]?.src : '');
      if (typeof img === 'object' && img !== null) {
        img = img.url || img.src || '';
      }
      if (typeof img === 'string' && img.trim().length > 0) {
        if (img.startsWith('//')) return 'https:' + img;
        if (img.startsWith('http://') || img.startsWith('https://') || img.startsWith('data:')) return img;
        return assetUrl(img);
      }
      return 'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%2244%22 height=%2244%22 viewBox=%220 0 44 44%22%3E%3Crect width=%2244%22 height=%2244%22 rx=%228%22 fill=%22%23F5F5F7%22/%3E%3Ctext x=%2222%22 y=%2226%22 text-anchor=%22middle%22 dominant-baseline=%22middle%22 font-family=%22system-ui%22 font-size=%2218%22 fill=%22%2386868B%22%3E💊%3C/text%3E%3C/svg%3E';
    }

    // Clear search button behavior
    if (btnClearSearch) {
      btnClearSearch.addEventListener('click', () => {
        searchInput.value = '';
        lastExecutedQuery = '';
        btnClearSearch.style.display = 'none';
        const spotlightBar = document.getElementById('apple-spotlight-bar');
        if (spotlightBar) spotlightBar.classList.remove('ai-active');
        if (searchDropdown) searchDropdown.classList.remove('active');
        renderProducts(PRODUCTS);
        searchInput.focus();
      });
    }

    // Instant local keyword mapper for Spanish natural language queries
    function extractLocalKeywords(q) {
      const qLow = q.toLowerCase();
      const terms = [];

      if (qLow.includes('diuret') || qLow.includes('retencion') || qLow.includes('liquido') || qLow.includes('deshinchar')) {
        terms.push('diuretico', 'hydra steel', 'cuts', 'quemador', 'carnitina');
      } else if (qLow.includes('grasa') || qLow.includes('bajar') || qLow.includes('peso') || qLow.includes('quemador') || qLow.includes('definir') || qLow.includes('adelgazar')) {
        terms.push('quemador', 'cuts', 'lipo', 'carnitina', 'lipodrene', 'burn');
      } else if (qLow.includes('muscul') || qLow.includes('masa') || qLow.includes('volumen') || qLow.includes('prote') || qLow.includes('hipertrofia') || qLow.includes('subir')) {
        terms.push('whey', 'isolate', 'iso 100', 'gold standard', 'mutant', 'proteina', 'creatina');
      } else if (qLow.includes('creatina') || qLow.includes('creapure') || qLow.includes('fuerza')) {
        terms.push('creatina', 'creapure', 'cbum', 'birdman', 'micronized');
      } else if (qLow.includes('pre') || qLow.includes('entreno') || qLow.includes('energia') || qLow.includes('bombeo') || qLow.includes('focus')) {
        terms.push('pre workout', 'psychotic', 'nitraflex', 'the omen', 'legend');
      } else if (qLow.includes('recuper') || qLow.includes('amino') || qLow.includes('bcaa') || qLow.includes('glutamina')) {
        terms.push('bcaa', 'glutamina', 'amino', 'recovery');
      }

      // Add individual meaningful words from query
      qLow.split(/\s+/).forEach(w => {
        const cleanW = w.replace(/[^a-z0-9áéíóúñ]/gi, '');
        if (cleanW.length >= 3 && !['para', 'con', 'que', 'los', 'las', 'una', 'uno', 'quiero', 'como', 'buen', 'buena', 'mas', 'sin'].includes(cleanW)) {
          terms.push(cleanW);
        }
      });

      return Array.from(new Set(terms));
    }

    // Query Shopify Predictive Search API (/search/suggest.json) with single term
    async function fetchShopifySearchTerm(term) {
      try {
        const endpoint = `/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[options][fields]=title,product_type,variants.title,vendor,tag&resources[options][unavailable_products]=last`;
        const response = await fetch(endpoint, {
          headers: { 'Accept': 'application/json' }
        });
        if (!response.ok) return [];
        const data = await response.json();
        return data.resources?.results?.products || [];
      } catch (e) {
        return [];
      }
    }

    // Search across Shopify database using natural language keyword expansion
    async function queryShopifyPredictiveSearch(q) {
      // 1. Direct query
      const directResults = await fetchShopifySearchTerm(q);
      if (directResults.length >= 3) {
        return directResults;
      }

      // 2. Multi-keyword expansion
      const keywords = extractLocalKeywords(q);
      const searchPromises = keywords.slice(0, 4).map(kw => fetchShopifySearchTerm(kw));
      const resultsArrays = await Promise.all(searchPromises);

      const merged = [...directResults];
      const seenIds = new Set(merged.map(p => p.id || p.handle));

      resultsArrays.forEach(arr => {
        arr.forEach(prod => {
          const id = prod.id || prod.handle;
          if (!seenIds.has(id)) {
            seenIds.add(id);
            merged.push(prod);
          }
        });
      });

      if (merged.length > 0) {
        return merged;
      }

      // 3. Fallback to in-memory store catalog (PRODUCTS)
      const qLow = q.toLowerCase();
      return PRODUCTS.filter(p => {
        const name = (p.name || p.title || '').toLowerCase();
        const brand = (p.brand || p.vendor || '').toLowerCase();
        const category = (p.category || p.type || '').toLowerCase();
        return name.includes(qLow) || brand.includes(qLow) || category.includes(qLow) || keywords.some(k => name.includes(k) || brand.includes(k) || category.includes(k));
      });
    }

    // AI Router Classifier: Distinguishes direct product/brand keywords from conversational questions
    function isConsultationQuery(q) {
      const text = (q || '').toLowerCase().trim();
      if (text.length < 4) return false;

      const triggers = [
        'quiero', 'busco', 'necesito', 'como', 'para que', 'sirve', 'que me recomiendas',
        'cual es', 'cual me', 'ayuda', 'recomienda', 'recomendacion', 'sugerir', 'sugieres',
        'bajar de peso', 'subir de peso', 'perder grasa', 'quemar grasa', 'eliminar retencion',
        'ganar musculo', 'masa muscular', 'aumentar masa', 'volumen', 'definicion', 'definir', 'subir musculo',
        'sin cafeina', 'sin estimulantes', 'para la noche', 'para entrenar', 'antes de entrenar',
        'despues de entrenar', 'recuperacion', 'dolor', 'articulaciones', 'energia', 'fuerza',
        'mejor proteina', 'mejor creatina', 'mejor quemador', 'mejor pre', 'limpio', 'limpia',
        'mujer', 'hombre', 'principiante', 'avanzado', 'efectos', 'tomar', 'dosificacion',
        'diuretico', 'diureticos', 'adolorido', 'mamado', 'panza', 'truena', 'rodilla', 'patas', 'bombear'
      ];

      if (triggers.some(t => text.includes(t))) return true;

      // Question words at start of query
      if (/^(¿\s*)?(que|cual|como|donde|por que|para que|cuando)\b/i.test(text)) return true;

      // Question mark only if phrase has at least 3 distinct words
      const words = text.split(/\s+/).filter(w => w.length > 0);
      if (/[¿?]/.test(text) && words.length >= 3) return true;

      // Long natural language sentence (5+ words)
      if (words.length >= 5) return true;

      return false;
    }

    // Fetch AI Advice from OpenRouter API in real time (Strict 2 short lines / ~25 words) with Memory Cache
    async function queryAiAdvisor(q) {
      const cacheKey = q.toLowerCase().trim();
      if (aiQueryCache.has(cacheKey)) {
        return aiQueryCache.get(cacheKey);
      }

      const config = window.BELUGA_AI_CONFIG || {};
      const model = config.openrouterModel || 'openrouter/free';

      const prompt = `Consulta del cliente: "${q}".
Responde ÚNICAMENTE en JSON con:
{
  "advice": "Consejo súper conciso de máximo 2 oraciones cortas (entre 20 y 30 palabras en total), directo y profesional para atletas en México.",
  "intent": "Nombre corto del objetivo (máximo 3 palabras)",
  "searchTerms": ["termino1", "termino2", "termino3"]
}`;

      // Sin key usable vamos directo al fallback local, sin tocar la red.
      if (!hasUsableAiKey()) {
        return buildLocalAdvice(q, cacheKey);
      }

      try {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 5000);

        const res = await fetch('https://openrouter.ai/api/v1/chat/completions', {
          method: 'POST',
          signal: controller.signal,
          headers: {
            'Authorization': `Bearer ${OPENROUTER_API_KEY}`,
            'Content-Type': 'application/json',
            'HTTP-Referer': window.location.origin || 'https://belugafitness.com',
            'X-Title': 'Beluga Fitness Storefront AI'
          },
          body: JSON.stringify({
            model: model,
            messages: [
              { role: 'system', content: 'Eres el Asesor Nutricional y Deportivo con Inteligencia Artificial de Beluga Fitness México. Tus respuestas deben ser sumamente breves (máximo 2 oraciones directas, ~25 palabras) para caber en 2 a 3 renglones. Responde ÚNICAMENTE en JSON válido.' },
              { role: 'user', content: prompt }
            ]
          })
        });
        clearTimeout(timeoutId);

        if (res.ok) {
          const data = await res.json();
          const rawContent = data.choices?.[0]?.message?.content || '';
          const parsed = safeJsonParse(rawContent);
          if (parsed && (parsed.advice || parsed.consejo)) {
            const aiRes = {
              source: 'openrouter',
              advice: parsed.advice || parsed.consejo,
              intent: parsed.intent || 'Asesoría Nutricional',
              searchTerms: Array.isArray(parsed.searchTerms) ? parsed.searchTerms : []
            };
            aiQueryCache.set(cacheKey, aiRes);
            return aiRes;
          }
        }
      } catch (err) {
        console.warn('[OpenRouter AI] Notice:', err.message);
      }

      return buildLocalAdvice(q, cacheKey);
    }

    // Fast Contextual NLP Heuristic Fallback
    function buildLocalAdvice(q, cacheKey) {
      const qLow = q.toLowerCase();
      let intent = 'Suplementación Prémium';
      let advice = 'Fórmulas 100% originales optimizadas para máxima absorción y rendimiento deportivo.';

      if (qLow.includes('diuret') || qLow.includes('retencion') || qLow.includes('liquido')) {
        intent = 'Definición & Pérdida de Líquidos';
        advice = 'Los diuréticos eliminan agua retenida. Combínalos con hidratación y electrolitos para no perder rendimiento.';
      } else if (qLow.includes('grasa') || qLow.includes('bajar') || qLow.includes('peso') || qLow.includes('quemador') || qLow.includes('definir')) {
        intent = 'Definición & Quema de Grasa';
        advice = 'Usa proteínas aisladas zero carbs y termogénicos controlados para acelerar tu metabolismo protegiendo el músculo.';
      } else if (qLow.includes('muscul') || qLow.includes('masa') || qLow.includes('volumen') || qLow.includes('prote') || qLow.includes('subir')) {
        intent = 'Aumento de Masa Muscular';
        advice = 'Combina proteína isolada con creatina monohidratada para acelerar la síntesis proteica y maximizar tu fuerza.';
      } else if (qLow.includes('fuerza') || qLow.includes('energia') || qLow.includes('pre') || qLow.includes('entreno')) {
        intent = 'Energía & Enfoque';
        advice = 'Toma pre-entreno 20 minutos antes de entrenar para bombeos musculares máximos y energía sostenida.';
      }

      const fallbackRes = {
        source: 'local-semantic',
        intent,
        advice,
        searchTerms: extractLocalKeywords(q)
      };
      aiQueryCache.set(cacheKey, fallbackRes);
      return fallbackRes;
    }

    // forceAi: el usuario pulso Enter (o "Buscar") con el modo IA encendido. Es una
    // senal explicita, mas fuerte que la heuristica de isConsultationQuery(), asi que
    // se manda el prompt al asesor tal cual lo escribio.
    async function handleSearchInput(forceAi = false) {
      const q = searchInput.value.trim();

      if (btnClearSearch) {
        btnClearSearch.style.display = q.length > 0 ? 'inline-flex' : 'none';
      }

      const spotlightBar = document.getElementById('apple-spotlight-bar');

      if (q.length === 0) {
        lastExecutedQuery = '';
        if (spotlightBar) spotlightBar.classList.remove('ai-active');
        if (searchDropdown) searchDropdown.classList.remove('active');
        renderProducts(PRODUCTS);
        return;
      }

      // Avoid redundant recalculations if query hasn't changed
      // (salvo Enter explicito: ahi el usuario pide re-ejecutar aunque no haya cambiado)
      if (q === lastExecutedQuery && !forceAi) return;
      currentQuery = q;

      const isConsultation = isAiModeEnabled && (forceAi || isConsultationQuery(q));

      if (isConsultation) {
        if (spotlightBar) spotlightBar.classList.add('ai-active');
        if (searchDropdown && searchResultsContainer) {
          searchResultsContainer.innerHTML = `
            <div class="apple-ai-loading-skeleton">
              <div class="apple-ai-shimmer-orb"></div>
              <div class="apple-ai-shimmer-text">
                ✨ Consultando asesor con Inteligencia Artificial...
              </div>
            </div>
          `;
          searchDropdown.classList.add('active');
        }
      } else {
        if (spotlightBar) spotlightBar.classList.remove('ai-active');
      }

      // Intelligent Router: If direct product search or AI Mode is disabled, query ONLY Shopify DB (0 API tokens!).
      // If consultation/question and AI mode is ON, run OpenRouter AI.
      const [products, aiResult] = await Promise.all([
        queryShopifyPredictiveSearch(q),
        isConsultation ? queryAiAdvisor(q) : Promise.resolve(null)
      ]);

      // Race condition check: user may have typed more
      if (searchInput.value.trim() !== currentQuery) return;
      lastExecutedQuery = currentQuery;

      // Se registra DESPUES del chequeo de carrera: asi solo cuenta la busqueda en la que
      // el cliente se detuvo, no cada pedazo que tecleo ("pro", "prote", "proteina").
      // results_count = 0 es la lista de productos que la gente busca y no tenemos.
      BelugaAnalytics.track('live_search', {
        query: q,
        results_count: products.length,
        ai_mode: Boolean(isAiModeEnabled),
        consultation: Boolean(isConsultation)
      });
      if (products.length === 0) BelugaAnalytics.track('search_no_results', { query: q });

      // Update in-page grid if matching products found
      if (products.length > 0) {
        renderProducts(products);
      }

      // Render autocomplete suggestions dropdown with AI Advice & Quick Add buttons
      if (searchDropdown && searchResultsContainer) {
        const allBrandsList = [...(BRANDS?.principales || []), ...(BRANDS?.otras || [])];
        const matchedBrands = allBrandsList.filter(b => b.toLowerCase().includes(q.toLowerCase())).slice(0, 3);

        const displayProducts = products.length > 0 ? products.slice(0, 4) : getCatalogProducts().slice(0, 3);

        // Intelligent Dynamic Bundle Synthesis (0 hardcoding — adapts to live Shopify store inventory)
        function composeDynamicBundle(query, productsList) {
          if (!productsList || productsList.length < 2) return null;
          const qLow = query.toLowerCase();
          const p1 = productsList[0];

          const t1 = `${p1.title || ''} ${p1.name || ''} ${p1.product_type || ''} ${p1.type || ''}`.toLowerCase();

          // Find optimal synergy partner dynamically from live store products
          let p2 = productsList.slice(1).find(p => {
            const t2 = `${p.title || ''} ${p.name || ''} ${p.product_type || ''} ${p.type || ''}`.toLowerCase();
            if (t1.includes('whey') || t1.includes('prote') || t1.includes('isolate') || t1.includes('mass')) {
              return t2.includes('creatina') || t2.includes('amino') || t2.includes('bcaa') || t2.includes('glutamina');
            }
            if (t1.includes('creatina')) {
              return t2.includes('whey') || t2.includes('prote') || t2.includes('isolate') || t2.includes('pre');
            }
            if (t1.includes('diuret') || t1.includes('hydra')) {
              return t2.includes('carnitina') || t2.includes('lipo') || t2.includes('burn') || t2.includes('cuts');
            }
            if (t1.includes('quemador') || t1.includes('cuts') || t1.includes('lipo') || t1.includes('burn')) {
              return t2.includes('carnitina') || t2.includes('diuret') || t2.includes('cla') || t2.includes('isolate');
            }
            if (t1.includes('pre') || t1.includes('psychotic') || t1.includes('nitraflex') || t1.includes('pump')) {
              return t2.includes('creatina') || t2.includes('bcaa') || t2.includes('amino') || t2.includes('clear');
            }
            if (t1.includes('colageno') || t1.includes('articul') || t1.includes('salud')) {
              return t2.includes('omega') || t2.includes('vitamina') || t2.includes('magnesio') || t2.includes('zmag');
            }
            return (p.id || p.handle) !== (p1.id || p1.handle);
          }) || productsList[1];

          const price1 = typeof p1.price === 'number' ? p1.price : (parseFloat(String(p1.price).replace(/[^0-9.]/g, '')) || 0);
          const price2 = typeof p2.price === 'number' ? p2.price : (parseFloat(String(p2.price).replace(/[^0-9.]/g, '')) || 0);
          const bundleTotal = price1 + price2;

          const v1 = p1.vendor || p1.brand || 'BELUGA';
          const v2 = p2.vendor || p2.brand || 'BELUGA';
          const brandLabel = v1.toUpperCase() === v2.toUpperCase() ? v1 : `${v1} + ${v2}`;

          // Clean short titles
          const cleanTitle1 = (p1.title || p1.name || '').replace(/\([^)]*\)/g, '').replace(/\d+\s*(lbs?|kg|caps?|ct|servicios?|g|ml)/gi, '').trim();
          const cleanTitle2 = (p2.title || p2.name || '').replace(/\([^)]*\)/g, '').replace(/\d+\s*(lbs?|kg|caps?|ct|servicios?|g|ml)/gi, '').trim();

          let subtitle = 'Combinación sinérgica diseñada para acelerar tus resultados deportivos.';
          if (qLow.includes('muscul') || qLow.includes('masa') || qLow.includes('volumen') || qLow.includes('subir')) {
            subtitle = 'Sinergia de construcción muscular magra y saturación de fuerza post-entreno.';
          } else if (qLow.includes('diuret') || qLow.includes('liquido') || qLow.includes('retencion')) {
            subtitle = 'Doble acción: eliminación de agua subcutánea y activación de energía lipolítica.';
          } else if (qLow.includes('grasa') || qLow.includes('bajar') || qLow.includes('peso') || qLow.includes('defin')) {
            subtitle = 'Acelera el gasto calórico y protege el tejido muscular durante déficit calórico.';
          } else if (qLow.includes('pre') || qLow.includes('energia') || qLow.includes('fuerza')) {
            subtitle = 'Enfoque explosivo, energía prolongada y bombeo muscular intenso sin bajones.';
          }

          return {
            p1,
            p2,
            title: `Pack ${brandLabel}: ${cleanTitle1.slice(0, 22)} + ${cleanTitle2.slice(0, 22)}`,
            subtitle,
            bundleTotal
          };
        }

        // Render AI Advice Box + Smart Bundle Pack Card if 2+ products match
        let aiAdviceHtml = '';
        if (aiResult && aiResult.advice) {
          const bundleVariant = pr => (pr.variantId || (pr.variants && pr.variants[0] && pr.variants[0].id) || '');
          const bundleHandle  = pr => (pr.handle || (String(pr.url || '').match(/\/products\/([^/?#]+)/) || [])[1] || '');

          let bundleHtml = '';
          const bundle = composeDynamicBundle(q, displayProducts);
          if (bundle) {
            const p1Img = resolveProductImageUrl(bundle.p1);
            const p2Img = resolveProductImageUrl(bundle.p2);
            const p1Title = bundle.p1.title || bundle.p1.name || 'Suplemento';
            const p2Title = bundle.p2.title || bundle.p2.name || 'Suplemento';
            const p1Price = typeof bundle.p1.price === 'number' ? bundle.p1.price : (parseFloat(String(bundle.p1.price).replace(/[^0-9.]/g, '')) || 0);
            const p2Price = typeof bundle.p2.price === 'number' ? bundle.p2.price : (parseFloat(String(bundle.p2.price).replace(/[^0-9.]/g, '')) || 0);

            const bundleItemsJson = escapeHtml(JSON.stringify([
              // Mismo motivo que en las sugerencias: nada de caer al id de producto.
              // Sin variante real va el handle y addToCart la resuelve.
              { id: bundleVariant(bundle.p1) || bundleHandle(bundle.p1), variantId: bundleVariant(bundle.p1) || undefined, handle: bundleHandle(bundle.p1), name: p1Title, title: p1Title, price: p1Price, brand: bundle.p1.vendor || bundle.p1.brand, image: p1Img, quantity: 1 },
              { id: bundleVariant(bundle.p2) || bundleHandle(bundle.p2), variantId: bundleVariant(bundle.p2) || undefined, handle: bundleHandle(bundle.p2), name: p2Title, title: p2Title, price: p2Price, brand: bundle.p2.vendor || bundle.p2.brand, image: p2Img, quantity: 1 }
            ]));

            bundleHtml = `
              <div class="apple-ai-bundle-card">
                <div class="apple-ai-bundle-top-row">
                  <div class="apple-ai-bundle-left">
                    <div class="apple-ai-bundle-thumbs">
                      <img class="apple-ai-bundle-thumb" src="${p1Img}" alt="${escapeHtml(p1Title)}">
                      <img class="apple-ai-bundle-thumb" src="${p2Img}" alt="${escapeHtml(p2Title)}">
                    </div>
                    <div class="apple-ai-bundle-info">
                      <span class="apple-ai-bundle-tag">⚡ Combo Recomendado</span>
                      <div class="apple-ai-bundle-title">${escapeHtml(bundle.title)}</div>
                    </div>
                  </div>
                </div>
                <div class="apple-ai-bundle-desc">${escapeHtml(bundle.subtitle)}</div>
                <div class="apple-ai-bundle-bottom-row">
                  <div class="apple-ai-bundle-price-wrap">
                    <span class="apple-ai-bundle-price tabular-nums">$${bundle.bundleTotal.toLocaleString('es-MX', { minimumFractionDigits: 2 })} MXN</span>
                    <span class="apple-ai-bundle-savings">✓ 10-30 días hábiles</span>
                  </div>
                  <button 
                    type="button" 
                    class="btn-add-bundle-cart" 
                    data-bundle="${bundleItemsJson}"
                    title="Añadir combo de 2 productos al carrito"
                  >
                    ⚡ Añadir Pack Completo
                  </button>
                </div>
              </div>
            `;
          }

          aiAdviceHtml = `
            <div class="apple-ai-advice-box">
              <div class="apple-ai-header-row">
                <span class="apple-ai-badge-label">
                  <span class="apple-ai-sparkle">✨</span> Asesor Inteligente con IA
                </span>
                <span class="apple-ai-intent-pill">🎯 ${escapeHtml(aiResult.intent || 'Objetivo Fitness')}</span>
              </div>
              <div class="apple-ai-advice-text">
                ${escapeHtml(aiResult.advice)}
              </div>
              ${bundleHtml}
              <p class="beluga-fineprint beluga-fineprint--ai-result">
                Respuesta generada con IA: puede contener errores u omitir información.
                Verifica el producto y su disponibilidad antes de comprar.
              </p>
            </div>
          `;
        }

        // Render Brands if found
        let brandsHtml = '';
        if (matchedBrands.length > 0) {
          brandsHtml = `
            <div style="padding: 10px 14px; border-bottom: 1px solid var(--apple-border-subtle); background: rgba(0, 122, 255, 0.03);">
              <div style="font-size: 11px; font-weight: 700; color: var(--apple-text-secondary); text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 6px;">🏷️ Marcas Encontradas</div>
              <div style="display: flex; gap: 6px; flex-wrap: wrap;">
                ${matchedBrands.map(b => `
                  <button type="button" data-brand-name="${escapeHtml(b)}" class="apple-brand-token" style="font-size: 11px; padding: 4px 10px; text-decoration: none; border-radius: 9999px; background: rgba(255,255,255,0.9); border: 1px solid var(--apple-border); color: var(--apple-text-primary); font-weight: 600; cursor: pointer; transition: all 0.15s ease;">
                    ${escapeHtml(b)} →
                  </button>
                `).join('')}
              </div>
            </div>
          `;
        }

        // Suggested Products List
        const suggestionsHtml = displayProducts.map(p => {
          const title = p.title || p.name || 'Suplemento';
          const vendor = p.vendor || p.brand || 'BELUGA FITNESS';
          const priceNum = typeof p.price === 'number' ? p.price : (parseFloat(String(p.price).replace(/[^0-9.]/g, '')) || 0);
          const priceFormatted = `$${priceNum.toLocaleString('es-MX', { minimumFractionDigits: 2 })} MXN`;
          const imgUrl = resolveProductImageUrl(p);
          const prodUrl = p.url || (p.handle ? `/products/${p.handle}` : '/collections/all');
          // OJO: no caer a p.id. /search/suggest.json devuelve variants: [] y su id es de
          // PRODUCTO; mandarlo a /cart/add.js da 422 "Cannot find variant". Si no hay
          // variante real la dejamos vacia y resolvemos por handle al momento de agregar.
          const variantId = p.variantId || (p.variants && p.variants[0] && p.variants[0].id) || '';
          const pHandle = p.handle || (String(p.url || '').match(/\/products\/([^/?#]+)/) || [])[1] || '';

          return `
            <div class="apple-suggest-row" style="text-decoration: none; display: flex; justify-content: space-between; align-items: center; padding: 10px 14px; border-bottom: 1px solid var(--apple-border-subtle); transition: background 0.15s ease;">
              <a href="${prodUrl}" class="apple-suggest-left" style="display: flex; align-items: center; gap: 12px; text-decoration: none; flex: 1; min-width: 0;">
                <img class="apple-suggest-img" src="${imgUrl}" alt="${escapeHtml(title)}" style="width: 44px; height: 44px; object-fit: contain; border-radius: 8px; background: #fff; padding: 2px; border: 1px solid var(--apple-border-subtle);" onerror="this.src='data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%2244%22 height=%2244%22 viewBox=%220 0 44 44%22%3E%3Crect width=%2244%22 height=%2244%22 rx=%228%22 fill=%22%23F5F5F7%22/%3E%3Ctext x=%2222%22 y=%2226%22 text-anchor=%22middle%22 dominant-baseline=%22middle%22 font-family=%22system-ui%22 font-size=%2218%22 fill=%22%2386868B%22%3E💊%3C/text%3E%3C/svg%3E'">
                <div style="min-width: 0;">
                  <div class="apple-suggest-brand" style="font-size: 11px; font-weight: 700; color: var(--apple-blue); text-transform: uppercase; letter-spacing: 0.04em;">${escapeHtml(vendor)}</div>
                  <div class="apple-suggest-name" style="font-size: 13px; font-weight: 600; color: var(--apple-text-primary); line-height: 1.3; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${escapeHtml(title)}</div>
                </div>
              </a>
              
              <div class="apple-suggest-right">
                <div class="apple-suggest-price tabular-nums">${priceFormatted}</div>
                <button 
                  type="button" 
                  class="btn-suggest-quick-add" 
                  data-id="${variantId}"
                  data-handle="${escapeHtml(pHandle)}"
                  data-title="${escapeHtml(title)}"
                  data-price="${priceNum}"
                  data-brand="${escapeHtml(vendor)}"
                  data-image="${imgUrl}"
                  title="Añadir a la Bolsa"
                >
                  + Añadir
                </button>
              </div>
            </div>
          `;
        }).join('');

        searchResultsContainer.innerHTML = `
          ${aiAdviceHtml}
          ${brandsHtml}
          ${displayProducts.length > 0 ? `
            <div class="apple-sheet-label" style="display: flex; justify-content: space-between; align-items: center; padding: 10px 14px 6px;">
              <span style="font-weight: 700; color: var(--apple-text-primary); font-size: 12px;">Productos Recomendados (${products.length > 0 ? 'En Stock' : 'Catálogo'})</span>
              <span style="font-size: 11px; color: var(--apple-text-secondary);">${displayProducts.length} producto${displayProducts.length !== 1 ? 's' : ''}</span>
            </div>
            ${suggestionsHtml}
          ` : ''}
          <div style="padding: 10px 14px; text-align: center; background: rgba(0,0,0,0.02); border-top: 1px solid var(--apple-border-subtle);">
            <a href="/search?q=${encodeURIComponent(q)}&type=product" style="font-size: 12px; font-weight: 600; color: var(--apple-blue); text-decoration: none;">
              Ver todos los resultados para "<strong>${escapeHtml(q)}</strong>" →
            </a>
          </div>
        `;

        // Attach Instant Quick Buy event listeners to individual '+ Añadir' buttons
        searchResultsContainer.querySelectorAll('.btn-suggest-quick-add').forEach(btn => {
          btn.addEventListener('click', async (e) => {
            e.preventDefault();
            e.stopPropagation();
            const id = btn.dataset.id;
            const handle = btn.dataset.handle || '';
            const title = btn.dataset.title;
            const price = parseFloat(btn.dataset.price);
            const brand = btn.dataset.brand;
            const image = btn.dataset.image;

            const original = btn.textContent;
            btn.disabled = true;
            btn.textContent = 'Añadiendo…';

            const ok = await addToCart({
              id: id || handle,
              variantId: id || undefined,   // vacio => addToCart lo resuelve por handle
              handle,
              name: title,
              title,
              brand,
              price,
              image,
              quantity: 1
            });

            // El estado solo refleja lo que Shopify acepto de verdad; antes decia
            // "Anadido" antes de intentarlo y el error solo iba al banner del drawer.
            if (ok) {
              btn.textContent = '✓ Añadido';
              btn.classList.add('added');
            } else {
              btn.textContent = 'No disponible';
            }

            setTimeout(() => {
              btn.textContent = original || '+ Añadir';
              btn.classList.remove('added');
              btn.disabled = false;
            }, 1800);
          });
        });

        // Attach Bundle Multi-Add event listener
        searchResultsContainer.querySelectorAll('.btn-add-bundle-cart').forEach(bundleBtn => {
          bundleBtn.addEventListener('click', async (e) => {
            e.preventDefault();
            e.stopPropagation();
            // Antes se ponia "Pack Anadido" ANTES de intentar el alta y los fallos solo
            // iban a console.error: el cliente veia exito con el carrito vacio.
            const original = '⚡ Añadir Pack Completo';
            try {
              const items = JSON.parse(bundleBtn.dataset.bundle || '[]');
              bundleBtn.disabled = true;
              bundleBtn.textContent = 'Añadiendo…';

              let agregados = 0;
              for (const item of items) {
                if (await addToCart(item)) agregados++;
              }

              if (agregados === items.length) {
                bundleBtn.textContent = '✓ ¡Pack Añadido!';
                bundleBtn.classList.add('added');
              } else if (agregados > 0) {
                bundleBtn.textContent = `Solo ${agregados} de ${items.length}`;
              } else {
                bundleBtn.textContent = 'No se pudo añadir';
              }

              setTimeout(() => {
                bundleBtn.textContent = original;
                bundleBtn.classList.remove('added');
                bundleBtn.disabled = false;
              }, 2200);
            } catch (err) {
              console.error('[Bundle Add Error]', err);
              bundleBtn.textContent = original;
              bundleBtn.disabled = false;
            }
          });
        });

        searchDropdown.classList.add('active');
      }
    }

    // Adaptive typing debounce: 850ms for AI advisory queries so user finishes sentence; 320ms for direct searches
    searchInput.addEventListener('input', () => {
      clearTimeout(debounceTimer);
      const val = searchInput.value.trim();
      if (val.length === 0) {
        handleSearchInput();
        return;
      }
      const delay = (isAiModeEnabled && isConsultationQuery(val)) ? 850 : 320;
      debounceTimer = setTimeout(() => handleSearchInput(), delay);
    });

    // Enter (o el boton "Buscar") con el modo IA ENCENDIDO: se manda solo el prompt al
    // asesor y no se navega a /search. El form es un GET nativo a routes.search_url, asi
    // que sin este preventDefault el Enter se lleva al usuario fuera de la pagina y la
    // respuesta del asesor nunca se alcanza a ver.
    // Con el modo IA apagado no se toca nada: submit nativo y busqueda de Shopify.
    const searchFormEl = document.getElementById('apple-search-form');
    if (searchFormEl) {
      searchFormEl.addEventListener('submit', (e) => {
        if (!isAiModeEnabled) return;
        const q = searchInput.value.trim();
        if (q.length === 0) return;

        e.preventDefault();
        clearTimeout(debounceTimer);
        // Cierra el teclado en movil: si no, tapa la respuesta del asesor.
        searchInput.blur();
        handleSearchInput(true);
      });
    }

    // 4.1 Kinetic Animated Placeholder Hints (Apple Spotlight Typing Animation)
    const SEARCH_HINTS = [
      "Buscar por marca (Dymatize, Optimum Nutrition, Mutant)...",
      "Buscar 'Creatina Creapure 300g'...",
      "Buscar 'ISO 100 Proteína Hidrolizada'...",
      "Buscar 'Psychotic Pre-Entreno'...",
      "Buscar 'Quemador Black Viper'...",
      "Buscar 'Gold Standard 100% Whey'..."
    ];
    let hintIdx = 0;
    let charIdx = 0;
    let isDeleting = false;
    let typingTimer = null;
    let isInputFocused = false;

    function animatePlaceholder() {
      if (isInputFocused || searchInput.value.trim().length > 0) return;

      const currentHint = SEARCH_HINTS[hintIdx];
      if (isDeleting) {
        charIdx--;
        searchInput.setAttribute('placeholder', currentHint.substring(0, charIdx));
        if (charIdx <= 0) {
          isDeleting = false;
          hintIdx = (hintIdx + 1) % SEARCH_HINTS.length;
          typingTimer = setTimeout(animatePlaceholder, 450);
          return;
        }
        typingTimer = setTimeout(animatePlaceholder, 25);
      } else {
        charIdx++;
        searchInput.setAttribute('placeholder', currentHint.substring(0, charIdx));
        if (charIdx >= currentHint.length) {
          isDeleting = true;
          typingTimer = setTimeout(animatePlaceholder, 2600); // Pause on complete hint
          return;
        }
        typingTimer = setTimeout(animatePlaceholder, 50);
      }
    }

    searchInput.addEventListener('focus', () => {
      isInputFocused = true;
      clearTimeout(typingTimer);
      searchInput.setAttribute('placeholder', 'Escribe una marca o suplemento...');
      if (searchInput.value.trim().length > 0) {
        handleSearchInput();
      }
    });

    searchInput.addEventListener('blur', () => {
      isInputFocused = false;
      if (searchInput.value.trim().length === 0) {
        charIdx = 0;
        isDeleting = false;
        clearTimeout(typingTimer);
        typingTimer = setTimeout(animatePlaceholder, 1000);
      }
    });

    // Start typing animation after brief delay
    setTimeout(animatePlaceholder, 1200);

    // Los chips de marca del dropdown se arman con datos del catalogo. Antes iban como
    // onclick="filterByBrandName('${escapeHtml(b)}')": escapar en HTML no protege dentro
    // de un string de JS, porque el parser decodifica &#39; a ' antes de que JS lo lea.
    // Una marca con apostrofo ("Nature's Bounty") rompia el literal -- y era inyeccion.
    // Con data-attribute + delegacion no hay contexto de JS en el atributo.
    document.addEventListener('click', (e) => {
      const chip = e.target.closest('.apple-brand-token[data-brand-name]');
      if (!chip) return;
      e.preventDefault();
      window.filterByBrandName(chip.dataset.brandName);
    });

    // Close dropdown on click outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.apple-search-center-wrap')) {
        if (searchDropdown) searchDropdown.classList.remove('active');
      }
    });
  }

  window.filterByBrandName = function(brandName) {
    if (searchInput) searchInput.value = brandName;
    if (btnClearSearch) btnClearSearch.classList.add('visible');
    if (searchDropdown) searchDropdown.classList.remove('active');
    filterCatalogByBrandOrQuery(brandName);
  };

  // ── Shopify Predictive Search API integration ───────────────────────────────
  // On real Shopify stores: queries /search/suggest.json for ALL catalog products
  // On static HTML demo: falls back to the local PRODUCTS array
  const IS_SHOPIFY = window.Shopify && window.Shopify.shop;
  let _searchDebounceTimer = null;

  async function fetchShopifyPredictiveSearch(query) {
    const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection&resources[limit]=8&resources[options][unavailable_products]=hide`;
    try {
      const res = await fetch(url, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!res.ok) return null;
      const data = await res.json();
      return data.resources?.results?.products || [];
    } catch (err) {
      return null;
    }
  }

  function filterCatalogByBrandOrQuery(query) {
    const q = (query || '').toLowerCase().trim();
    const catalog = getCatalogProducts();

    if (!q || q === 'all') {
      renderProducts(catalog);
      return;
    }

    const normQ = q.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

    const inMemoryFiltered = catalog.filter(p => {
      const brand = (p.brand || p.vendor || '').toLowerCase();
      const name = (p.name || p.title || '').toLowerCase();
      const cat = (p.category || p.type || '').toLowerCase();

      const normBrand = brand.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      const normName = name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      const normCat = cat.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

      return normBrand.includes(normQ) || normName.includes(normQ) || normCat.includes(normQ);
    });

    if (inMemoryFiltered.length > 0) {
      renderProducts(inMemoryFiltered);
      return;
    }

    if (IS_SHOPIFY) {
      // Use Shopify's native predictive search for broader catalog search
      clearTimeout(_searchDebounceTimer);
      _searchDebounceTimer = setTimeout(async () => {
        const shopifyResults = await fetchShopifyPredictiveSearch(q);
        if (shopifyResults && shopifyResults.length > 0) {
          const mapped = shopifyResults.map(p => ({
            id:            p.handle || p.id,
            name:          p.title,
            brand:         p.vendor || 'BELUGA FITNESS',
            category:      p.product_type ? p.product_type.toLowerCase() : 'suplementos',
            price:         p.price ? parseFloat(String(p.price).replace(/[^0-9.]/g, '')) : 0,
            originalPrice: p.compare_at_price ? parseFloat(String(p.compare_at_price).replace(/[^0-9.]/g, '')) : 0,
            rating:        4.8,
            reviews:       100,
            image:         p.image?.url || p.featured_image?.url || '',
            url:           p.url || `/products/${p.handle}`
          }));
          renderProducts(mapped);
        } else {
          renderProducts([]);
        }
      }, 180);
    } else {
      renderProducts([]);
    }
  }

  // 5. Category & Quick Pill Filtering
  function setupCategoryFiltering() {
    document.querySelectorAll('.apple-filter-chip, .quick-filter-pill').forEach(pill => {
      pill.addEventListener('click', () => {
        // Los chips que `category-nav` pinta son enlaces de verdad a una coleccion: no
        // traen `data-filter` y su trabajo es navegar. Sin esta guarda entraban igual al
        // filtrado de aqui abajo con `filter === undefined`, que cae en el else, escribe
        // la cadena "undefined" en el buscador y lanza un filtrado del catalogo contra
        // ella. La navegacion suele ganar la carrera y taparlo, pero en un movil lento se
        // alcanza a ver el buscador lleno de basura antes de cambiar de pagina.
        const filter = pill.dataset.filter;
        if (!filter) return;

        document.querySelectorAll('.apple-filter-chip, .quick-filter-pill').forEach(p => p.classList.remove('active'));
        pill.classList.add('active');

        if (filter === 'all') {
          if (searchInput) searchInput.value = '';
          if (btnClearSearch) btnClearSearch.classList.remove('visible');
          renderProducts(PRODUCTS);
        } else {
          if (searchInput) searchInput.value = filter;
          if (btnClearSearch) btnClearSearch.classList.add('visible');
          filterCatalogByBrandOrQuery(filter);
        }
      });
    });
  }

  // 6. PDP Controls, Gallery & Sticky Buy Bar
  function setupPDPControls() {
    pdpThumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        pdpThumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        if (pdpMainImg) pdpMainImg.src = thumb.dataset.src;
      });
    });

    // Interceptamos el SUBMIT del form (no el click del boton): cubre el click,
    // la tecla Enter y la barra sticky, y evita el doble alta que se producia
    // cuando el POST nativo corria en paralelo con el fetch AJAX.
    const pdpFormEl = document.querySelector('form[action*="/cart/add"]');
    if (pdpFormEl) {
      pdpFormEl.addEventListener('submit', (e) => {
        e.preventDefault();
        triggerAddToCartFromPdp();
      });
    } else if (btnPdpAddToCart) {
      btnPdpAddToCart.addEventListener('click', (e) => {
        e.preventDefault();
        triggerAddToCartFromPdp();
      });
    }

    // Sticky Buy Bar on Scroll Trigger
    if (stickyPdpBar && btnPdpAddToCart) {
      if ('IntersectionObserver' in window) {
        const stickyObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            stickyPdpBar.classList.toggle('active', !entry.isIntersecting && entry.boundingClientRect.bottom < 0);
          });
        }, { threshold: 0 });
        stickyObserver.observe(btnPdpAddToCart);
      } else {
        window.addEventListener('scroll', () => {
          stickyPdpBar.classList.toggle('active', btnPdpAddToCart.getBoundingClientRect().bottom < 0);
        }, { passive: true });
      }
    }

    document.querySelectorAll('.pdp-tab-item').forEach(item => {
      const header = item.querySelector('.pdp-tab-header');
      if (header) {
        header.addEventListener('click', () => {
          const isOpen = item.classList.contains('open');
          document.querySelectorAll('.pdp-tab-item').forEach(i => i.classList.remove('open'));
          if (!isOpen) item.classList.add('open');
        });
      }
    });
  }

  function triggerAddToCartFromPdp() {
    const pdpForm = document.querySelector('form[action*="/cart/add"]') || (btnPdpAddToCart ? btnPdpAddToCart.closest('form') : null);
    if (!pdpForm) return;

    let variantId = null;
    let title = 'Suplemento Beluga';
    let brand = 'BELUGA FITNESS';
    let price = 0;
    let image = assetUrl('prod-whey.jpg');
    let quantity = 1;

    // El stepper de la PDP escribe en el input oculto: esa es la cantidad real.
    const qtyInput = pdpForm.querySelector('input[name="quantity"]');
    if (qtyInput) quantity = parseInt(qtyInput.value, 10) || 1;
    const variantInput = pdpForm.querySelector('input[name="id"]');
    if (variantInput && variantInput.value) {
      variantId = parseInt(variantInput.value, 10);
    }
    const titleElem = document.querySelector('.apple-pdp-title');
    if (titleElem) title = titleElem.textContent.trim();
    const brandElem = document.querySelector('.apple-pdp-eyebrow');
    if (brandElem) brand = brandElem.textContent.trim();
    const priceElem = document.getElementById('pdp-price-display');
    if (priceElem) {
      price = parseFloat(priceElem.textContent.replace(/[^0-9.]/g, '')) || 0;
    }
    const imgElem = document.getElementById('pdp-main-img');
    if (imgElem && imgElem.src) image = imgElem.src;

    if (btnPdpAddToCart) {
      btnPdpAddToCart.innerHTML = `<span>✓ Agregado a la Bolsa</span>`;
      btnPdpAddToCart.style.background = 'var(--apple-green)';
      setTimeout(() => {
        btnPdpAddToCart.innerHTML = `
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <path d="M16 10a4 4 0 0 1-8 0"></path>
          </svg>
          <span>Añadir a la Bolsa</span>
        `;
        btnPdpAddToCart.style.background = 'var(--apple-blue)';
      }, 1200);
    }

    const pdpHandle = (window.location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || '';
    const pdpUrl = window.location.pathname;

    addToCart({
      id: variantId || pdpHandle || `pdp-${title}`,
      variantId: variantId,
      handle: pdpHandle,
      url: pdpUrl,
      name: title,
      title: title,
      brand: brand,
      price: price,
      originalPrice: price,
      image: image,
      quantity: quantity
    });
  }

  // 10. Cart Drawer Logic & Upsells
  function setupCartDrawer() {
    const trigger = document.getElementById('btn-cart-toggle') || cartTriggerBtn;
    const closeBtn = document.getElementById('btn-close-cart') || closeCartBtn;
    const overlay = document.getElementById('cart-drawer-overlay') || cartDrawerOverlay;

    if (trigger) trigger.addEventListener('click', openCart);
    if (closeBtn) closeBtn.addEventListener('click', closeCart);
    if (overlay) {
      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) closeCart();
      });
    }

    document.querySelectorAll('.btn-checkout-primary, #btn-cart-checkout').forEach(btn => {
      btn.addEventListener('click', (e) => {
        // Inside Shopify Design Mode (Theme Customizer Preview)
        if (window.Shopify && window.Shopify.designMode) {
          e.preventDefault();
          const orig = btn.textContent;
          btn.textContent = 'Redirigiendo a Bolsa...';
          setTimeout(() => {
            btn.textContent = orig;
            window.location.href = '/cart';
          }, 300);
          return;
        }

        // On Live Storefront: instantaneous checkout transition
        btn.textContent = 'Procesando Pago Seguro...';
        const form = btn.closest('form');
        if (!form) {
          e.preventDefault();
          window.location.href = '/checkout';
        }
      });
    });
  }

  function openCart() {
    const overlay = document.getElementById('cart-drawer-overlay') || cartDrawerOverlay;
    if (overlay) {
      if (!overlay.classList.contains('active')) {
        BelugaAnalytics.track('cart_opened', { page_path: window.location.pathname });
      }
      overlay.classList.add('active');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      const first = overlay.querySelector('#btn-close-cart');
      if (first) first.focus({ preventScroll: true });
    }
  }

  function closeCart() {
    const overlay = document.getElementById('cart-drawer-overlay') || cartDrawerOverlay;
    if (overlay) {
      overlay.classList.remove('active');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  }

  // ═══════════════════════════════════════════════════════════════════════════
  //  BELUGA ANALYTICS HUB — Conecta GA4, Meta, TikTok, Klaviyo, Pinterest,
  //  GTM dataLayer y el sistema nativo de Shopify desde un solo punto central.
  // ═══════════════════════════════════════════════════════════════════════════
  const BelugaAnalytics = {

    /**
     * track(event, data)
     * Dispara el evento en TODOS los canales activos.
     * Llamar con: BelugaAnalytics.track('add_to_cart', { product, quantity, value })
     */
    track(event, data = {}) {
      this._shopify(event, data);
      this._ga4(event, data);
      this._clarity(event, data);
      this._meta(event, data);
      this._tiktok(event, data);
      this._klaviyo(event, data);
      this._pinterest(event, data);
      this._gtmDataLayer(event, data);
      // Custom DOM event para App Partners (Recharge, Gorgias, etc.)
      document.dispatchEvent(new CustomEvent(`beluga:${event}`, { detail: data }));
    },

    // ── Shopify Native Analytics ─────────────────────────────────────────────
    _shopify(event, data) {
      try {
        if (window.Shopify?.analytics?.publish) {
          window.Shopify.analytics.publish(event, data);
        }
      } catch (e) { /* silent */ }
    },

    // ── Google Analytics 4 ───────────────────────────────────────────────────
    // Solo eventos de COMPORTAMIENTO del tema. Las vistas de pagina y el embudo de compra
    // (view_item, add_to_cart, begin_checkout, purchase, search) ya los manda a GA4 la app
    // Google & YouTube desde Eventos de cliente, que tambien ve el checkout. Repetirlos aqui
    // duplicaria las conversiones de la misma propiedad.
    _ga4(event, data) {
      if (typeof window.belugaGtag !== 'function') return;
      const COVERED_BY_APP = new Set([
        'product_viewed', 'add_to_cart', 'product_added_to_cart', 'remove_from_cart',
        'begin_checkout', 'purchase', 'search'
      ]);
      if (COVERED_BY_APP.has(event)) return;
      // GA4 solo acepta parametros planos: se copian los textos, numeros y booleanos.
      const payload = {};
      Object.keys(data).forEach(k => {
        const v = data[k];
        if (['string', 'number', 'boolean'].includes(typeof v)) {
          payload[k === 'query' ? 'search_term' : k] = typeof v === 'string' ? v.slice(0, 100) : v;
        }
      });
      window.belugaGtag('event', event, payload);
    },

    // ── Microsoft Clarity ────────────────────────────────────────────────────
    // Marca las grabaciones para poder filtrarlas: "sesiones con search_no_results",
    // "sesiones con cart_error", etc. Las etiquetas (set) quedan pegadas a la sesion.
    _clarity(event, data) {
      if (typeof window.clarity !== 'function') return;
      try {
        window.clarity('event', event);
        if (event === 'product_added_to_cart') window.clarity('set', 'agrego_al_carrito', 'si');
        if (event === 'search_no_results' && data.query) window.clarity('set', 'busqueda_sin_resultados', String(data.query).slice(0, 100));
        if (event === 'cart_error') window.clarity('set', 'error_carrito', 'si');
      } catch (e) { /* silent */ }
    },

    // ── Meta (Facebook) Pixel ────────────────────────────────────────────────
    _meta(event, data) {
      if (typeof window.belugaFbq !== 'function') return;
      const MAP = {
        'product_viewed':  ['ViewContent', {
          content_type: 'product',
          content_ids: data.product ? [String(data.product.id)] : [],
          content_name: data.product?.name,
          currency: 'MXN',
          value: (data.product?.price || 0) * (data.quantity || 1)
        }],
        'add_to_cart':     ['AddToCart', {
          content_type: 'product',
          content_ids: data.product ? [String(data.product.id)] : [],
          currency: 'MXN',
          value: (data.product?.price || 0) * (data.quantity || 1)
        }],
        'begin_checkout':  ['InitiateCheckout', { currency: 'MXN', value: data.value }],
        'purchase':        ['Purchase', { currency: 'MXN', value: data.value, order_id: data.order_id }],
        'search':          ['Search', { search_string: data.query }],
      };
      const mapped = MAP[event];
      if (mapped) window.belugaFbq('track', ...mapped);
    },

    // ── TikTok Pixel ─────────────────────────────────────────────────────────
    _tiktok(event, data) {
      if (typeof window.belugaTtq === 'undefined') return;
      const MAP = {
        'product_viewed':  ['ViewContent', {
          content_id: data.product?.id ? String(data.product.id) : undefined,
          content_name: data.product?.name,
          currency: 'MXN',
          value: (data.product?.price || 0) * (data.quantity || 1)
        }],
        'add_to_cart':     ['AddToCart', {
          content_id: data.product?.id ? String(data.product.id) : undefined,
          currency: 'MXN',
          value: (data.product?.price || 0) * (data.quantity || 1)
        }],
        'begin_checkout':  ['InitiateCheckout', { currency: 'MXN', value: data.value }],
        'purchase':        ['PlaceAnOrder', { currency: 'MXN', value: data.value, order_id: data.order_id }],
      };
      const mapped = MAP[event];
      if (mapped) window.belugaTtq.track(...mapped);
    },

    // ── Klaviyo ──────────────────────────────────────────────────────────────
    _klaviyo(event, data) {
      if (!window.belugaKlaviyo) return;
      const MAP = {
        'add_to_cart':    'Added to Cart',
        'begin_checkout': 'Started Checkout',
        'search':         'Searched',
      };
      const klEvent = MAP[event];
      if (!klEvent) return;
      window.belugaKlaviyo.push(['track', klEvent, {
        ProductName: data.product?.name,
        ProductID:   data.product?.id,
        Price:       data.product?.price,
        Quantity:    data.quantity || 1,
        Value:       data.value,
        URL:         window.location.href,
      }]);
    },

    // ── Pinterest Tag ─────────────────────────────────────────────────────────
    _pinterest(event, data) {
      if (typeof window.pintrk === 'undefined') return;
      const MAP = {
        'add_to_cart':    'addtocart',
        'begin_checkout': 'checkout',
        'purchase':       'checkout',
      };
      const pEvent = MAP[event];
      if (!pEvent) return;
      window.pintrk('track', pEvent, {
        value:    data.value || (data.product?.price || 0) * (data.quantity || 1),
        currency: 'MXN',
        line_items: data.product ? [{
          product_id:   data.product.id,
          product_name: data.product.name,
          product_price: data.product.price,
          product_quantity: data.quantity || 1
        }] : []
      });
    },

    // ── Google Tag Manager dataLayer ──────────────────────────────────────────
    _gtmDataLayer(event, data) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event:            `beluga_${event}`,
        ecommerce: {
          currency:       'MXN',
          value:          data.value || (data.product ? data.product.price * (data.quantity || 1) : 0),
          items:          data.product ? [{
            item_id:      String(data.product.id),
            item_name:    data.product.name,
            item_brand:   data.product.brand,
            price:        data.product.price,
            quantity:     data.quantity || 1
          }] : (data.cart || []).map(i => ({
            item_id:      String(i.id),
            item_name:    i.name,
            item_brand:   i.brand,
            price:        i.price,
            quantity:     i.quantity
          })),
          ...(data.order_id ? { transaction_id: data.order_id } : {}),
          ...(data.query    ? { search_term:    data.query    } : {}),
        }
      });
    },
  };

  // Mutar una linea del carrito. Serializa las peticiones: antes cada clic disparaba
  // su propio /cart/change.js en paralelo y la cantidad final era la del ultimo que
  // llegara, no la del ultimo que el cliente pidio. Ademas ahora leemos la respuesta:
  // si Shopify rechaza (tope de inventario) se lo decimos en vez de revertir en silencio.
  let cartMutationLock = false;
  async function changeCartLine(payload, sourceEl) {
    if (cartMutationLock) return null;
    cartMutationLock = true;
    if (sourceEl) sourceEl.disabled = true;

    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!res.ok) {
        let reason = '';
        try {
          const err = await res.json();
          reason = err.description || err.message || '';
        } catch (_) { /* respuesta no-JSON */ }
        if (typeof showCartError === 'function') {
          showCartError(reason || 'No pudimos actualizar la cantidad. Puede que no haya más inventario.');
        }
        return null;
      }
      return await res.json();
    } catch (e) {
      console.warn('Shopify cart change notice:', e);
      return null;
    } finally {
      cartMutationLock = false;
      if (sourceEl) sourceEl.disabled = false;
    }
  }

  // escapeHtml a nivel de modulo: las dos copias que existian estaban anidadas dentro
  // de otras funciones, asi que updateCartUI inyectaba titulos de producto sin escapar.
  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, m => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    })[m]);
  }

  // Un solo formateador de dinero. Antes el drawer usaba toLocaleString sin decimales
  // ("$1,549.5") y la pagina de carrito usaba el filtro | money ("$1,549.50").
  const belugaMoneyFmt = new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: (window.BELUGA_SHOP && window.BELUGA_SHOP.currency) || 'MXN',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  function fmtMoney(amount) {
    return belugaMoneyFmt.format(Number(amount) || 0);
  }

  // Shorthand alias
  function publishShopifyAnalytics(eventName, data) {
    BelugaAnalytics.track(eventName, data);
  }

  // FUENTE DE VERDAD: el carrito real es el de Shopify (/cart.js), no localStorage.
  // Antes solo se sincronizaba cuando Shopify devolvia items, asi que un carrito
  // viejo en localStorage sobrevivia para siempre: el drawer mostraba productos que
  // el checkout no tenia. Ahora un carrito vacio en Shopify tambien vacia el local.
  async function syncCartWithShopify() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (res.ok) {
        const shopifyCart = await res.json();
        if (shopifyCart && Array.isArray(shopifyCart.items)) {
          if (shopifyCart.items.length === 0) {
            cart = [];
          } else {
            cart = shopifyCart.items.map(item => ({
              id: String(item.variant_id || item.id),
              variantId: item.variant_id || item.id,
              name: item.product_title || item.title,
              title: item.product_title || item.title,
              brand: item.vendor || 'BELUGA FITNESS',
              price: item.price / 100,
              originalPrice: (item.original_price || item.price) / 100,
              image: normalizeImageUrl(item.image || item.featured_image?.url || ''),
              quantity: item.quantity
            }));
          }
          saveCart();
          updateCartUI();
        }
      }
    } catch (e) {
      // Offline fallback
    }
  }

  // /search/suggest.json devuelve los productos con variants: [] y sin variantId, asi que
  // la cadena de fallback terminaba mandando el id de PRODUCTO a /cart/add.js y Shopify
  // respondia 422 "Cannot find variant". Aqui resolvemos la variante real desde
  // /products/{handle}.js solo cuando hace falta: las tarjetas de la grid y el blob del
  // catalogo ya traen variantId y no tocan la red.
  const variantIdCache = new Map();
  async function resolveVariantId(product) {
    if (!product) return null;

    // 1. Direct valid numeric variantId check (debe ser un entero numerico positivo de Shopify)
    const direct = product.variantId || (product.variants && product.variants[0] && product.variants[0].id);
    if (direct) {
      const strDirect = String(direct).trim();
      if (/^\d+$/.test(strDirect) && (!product.productId || strDirect !== String(product.productId))) {
        return parseInt(strDirect, 10);
      }
    }

    // 2. Extraer handle desde el producto, URL o la ubicacion actual
    let handle = product.handle || (String(product.url || '').match(/\/products\/([^/?#]+)/) || [])[1];

    // Si no viene handle, buscar en el catalogo cargado en memoria (BELUGA_STORE_PRODUCTS)
    if (!handle && typeof window !== 'undefined' && Array.isArray(window.BELUGA_STORE_PRODUCTS)) {
      const pMatch = window.BELUGA_STORE_PRODUCTS.find(p =>
        (product.productId && String(p.productId) === String(product.productId)) ||
        (product.title && p.title && p.title.trim().toLowerCase() === product.title.trim().toLowerCase()) ||
        (product.name && p.name && p.name.trim().toLowerCase() === product.name.trim().toLowerCase())
      );
      if (pMatch) {
        if (pMatch.variantId && /^\d+$/.test(String(pMatch.variantId))) {
          return parseInt(pMatch.variantId, 10);
        }
        handle = pMatch.handle || (String(pMatch.url || '').match(/\/products\/([^/?#]+)/) || [])[1];
      }
    }

    if (!handle && typeof window !== 'undefined' && window.location.pathname.includes('/products/')) {
      handle = (window.location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
    }

    if (!handle) return null;
    if (variantIdCache.has(handle)) return variantIdCache.get(handle);

    let resolved = null;
    try {
      const res = await fetch('/products/' + encodeURIComponent(handle) + '.js');
      if (res.ok) {
        const full = await res.json();
        const vs = full.variants || [];
        const v = vs.find(x => x.available) || vs[0];
        if (v && v.id) resolved = parseInt(v.id, 10);
      }
    } catch (e) {
      console.warn('[Beluga] no se pudo resolver la variante de', handle, e);
    }
    if (resolved) variantIdCache.set(handle, resolved);
    return resolved;
  }

  async function addToCart(product) {
    if (!product) return false;
    const resolvedId = await resolveVariantId(product);
    let rawVariantId = resolvedId || product.variantId;
    let variantId = (/^\d+$/.test(String(rawVariantId || '').trim())) ? parseInt(rawVariantId, 10) : null;
    const handle = product.handle || (String(product.url || '').match(/\/products\/([^/?#]+)/) || [])[1] || (window.location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
    const qtyToAdd = parseInt(product.quantity, 10) || 1;
    const itemPrice = parseFloat(product.price) || 0;
    const itemTitle = product.name || product.title || 'Suplemento';
    const itemBrand = product.brand || product.vendor || 'BELUGA FITNESS';
    const itemImage = product.image || assetUrl('prod-whey.jpg');
    const itemId = String(variantId || handle || product.id || itemTitle);

    // 1. Optimistic instant local cart addition (Guarantees immediate drawer render & resilience)
    const existing = cart.find(item => String(item.id) === itemId || (variantId && item.variantId === variantId));
    if (existing) {
      existing.quantity += qtyToAdd;
    } else {
      cart.push({
        id: itemId,
        variantId: variantId || null,
        name: itemTitle,
        title: itemTitle,
        brand: itemBrand,
        price: itemPrice,
        originalPrice: parseFloat(product.originalPrice || itemPrice) || itemPrice,
        image: itemImage,
        quantity: qtyToAdd
      });
    }
    saveCart();
    updateCartUI();
    openCart();

    let ok = false;

    // Helper: envio a /cart/add.js usando FormData estandar para Shopify
    async function postVariantToShopify(vId, qty) {
      const formData = new FormData();
      formData.append('id', String(vId));
      formData.append('quantity', String(qty));
      return await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      });
    }

    // 2. Confirmar contra Shopify. Si falla (agotado, variante inexistente, limite de
    //    inventario) revertimos el alta optimista y se lo decimos al cliente.
    if (variantId && variantId > 0) {
      try {
        let res = await postVariantToShopify(variantId, qtyToAdd);

        // Auto-recuperacion en caso de 422 ("Cannot find variant" / variante desactualizada):
        // si tenemos el handle del producto, consultamos su JSON fresco y reintentamos.
        if (!res.ok && handle) {
          try {
            const freshRes = await fetch('/products/' + encodeURIComponent(handle) + '.js');
            if (freshRes.ok) {
              const fullProd = await freshRes.json();
              const vs = fullProd.variants || [];
              const freshV = vs.find(x => x.available) || vs[0];
              if (freshV && freshV.id && parseInt(freshV.id, 10) !== variantId) {
                variantId = parseInt(freshV.id, 10);
                variantIdCache.set(handle, variantId);
                res = await postVariantToShopify(variantId, qtyToAdd);
              }
            }
          } catch (_) { /* fallo recuperacion */ }
        }

        if (res.ok) {
          await syncCartWithShopify();
          ok = true;
        } else {
          let reason = '';
          try {
            const err = await res.json();
            reason = err.description || err.message || '';
          } catch (_) { /* respuesta no-JSON */ }

          await syncCartWithShopify(); // vuelve al carrito real de Shopify
          showCartError(reason || 'No pudimos agregar este producto. Puede estar agotado.');
        }
      } catch (e) {
        // Sin red / Dev mode: dejamos el alta optimista
        console.warn('Shopify cart network notice:', e);
        ok = true;
      }
    } else if (handle) {
      // Si la variante venia vacia pero tenemos handle, resolverla directamente
      try {
        const freshRes = await fetch('/products/' + encodeURIComponent(handle) + '.js');
        if (freshRes.ok) {
          const fullProd = await freshRes.json();
          const vs = fullProd.variants || [];
          const freshV = vs.find(x => x.available) || vs[0];
          if (freshV && freshV.id) {
            variantId = parseInt(freshV.id, 10);
            variantIdCache.set(handle, variantId);
            const res = await postVariantToShopify(variantId, qtyToAdd);
            if (res.ok) {
              await syncCartWithShopify();
              ok = true;
            } else {
              await syncCartWithShopify();
              showCartError('No pudimos agregar este producto. Puede estar agotado.');
            }
          }
        }
      } catch (e) {
        console.warn('Shopify cart handle resolution notice:', e);
      }
      if (!ok) {
        showCartError('No pudimos identificar la presentación de este producto. Ábrelo para elegirla.');
      }
    } else {
      showCartError('No pudimos identificar la presentación de este producto. Ábrelo para elegirla.');
    }

    // Solo si Shopify acepto el alta: antes se publicaba tambien cuando fallaba.
    if (ok) {
      publishShopifyAnalytics('product_added_to_cart', {
        product: product,
        cart: cart
      });
    }

    return ok;
  }

  // Mensaje de error dentro del drawer (Shopify rechazo el alta).
  function showCartError(message) {
    // Todos los rechazos del carrito pasan por aqui: agotados, topes de inventario,
    // variantes que no se pudieron resolver. Es la señal de friccion mas directa que hay.
    BelugaAnalytics.track('cart_error', { reason: message, page_path: window.location.pathname });
    const host = document.getElementById('cart-drawer-items');
    if (!host) { console.warn('[Beluga cart]', message); return; }
    let box = document.getElementById('cart-error-banner');
    if (!box) {
      box = document.createElement('div');
      box.id = 'cart-error-banner';
      box.setAttribute('role', 'alert');
      box.style.cssText = 'margin:0;padding:10px 20px;background:rgba(255,59,48,0.08);color:#D70015;font-size:13px;font-weight:600;line-height:1.4;';
      // Va como hermano ANTES del contenedor de items, no dentro: updateCartUI()
      // reescribe el innerHTML de #cart-drawer-items y se llevaria el aviso justo
      // cuando la reconciliacion con Shopify lo hace necesario.
      host.parentNode.insertBefore(box, host);
    }
    box.textContent = message;
    box.style.display = '';
    clearTimeout(showCartError._t);
    showCartError._t = setTimeout(() => { box.style.display = 'none'; }, 6000);
  }

  function saveCart() {
    localStorage.setItem('beluga_cart', JSON.stringify(cart));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
  }

  function updateCartUI() {
    if (!cartItemsContainer) return;

    if (cart.length === 0) {
      cartItemsContainer.innerHTML = `
        <div style="text-align: center; padding: 48px 16px; color: var(--apple-text-secondary);">
          <div style="width: 44px; height: 44px; margin: 0 auto 12px; color: var(--apple-text-tertiary); display: flex; align-items: center; justify-content: center;">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <path d="M16 10a4 4 0 0 1-8 0"></path>
            </svg>
          </div>
          <h4 style="font-size: 15px; font-weight: 700; color: var(--apple-text-primary); margin-bottom: 4px;">Tu bolsa está vacía</h4>
          <p style="font-size: 13px;">Explora el catálogo y aprovecha los precios directos de distribuidor.</p>
        </div>
      `;
    } else {
      let itemsHtml = cart.map(item => `
        <div class="apple-cart-item" data-id="${escapeHtml(String(item.id))}">
          <img src="${escapeHtml(item.image || '')}" alt="${escapeHtml(item.name || '')}" loading="lazy" width="80" height="80" onerror="this.src='data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%2280%22 height=%2280%22 viewBox=%220 0 80 80%22%3E%3Crect width=%2280%22 height=%2280%22 fill=%22%23F5F5F7%22/%3E%3Ctext x=%2240%22 y=%2240%22 text-anchor=%22middle%22 dominant-baseline=%22middle%22 font-family=%22system-ui%22 font-size=%2224%22 fill=%22%23AEAEB2%22%3E🏋️%3C/text%3E%3C/svg%3E'">
          <div style="flex: 1; min-width: 0;">
            <div style="font-size: 10px; font-weight: 700; color: var(--apple-blue); text-transform: uppercase; letter-spacing: 0.05em;">${escapeHtml(item.brand || '')}</div>
            <div style="font-size: 13px; font-weight: 600; color: var(--apple-text-primary); line-height: 1.3; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${escapeHtml(item.name || '')}</div>
            <div style="display: flex; align-items: center; gap: 8px; margin-top: 6px;">
              <div class="apple-stepper-box" style="padding: 0 2px;">
                <button class="apple-stepper-btn btn-minus" data-id="${item.id}" style="width: 24px; height: 26px; font-size: 14px;">−</button>
                <span class="apple-stepper-val tabular-nums" style="width: 22px; font-size: 13px;">${item.quantity}</span>
                <button class="apple-stepper-btn btn-plus" data-id="${item.id}" style="width: 24px; height: 26px; font-size: 14px;">+</button>
              </div>
              <button class="btn-cart-delete" data-id="${item.id}" style="font-size: 11px; color: var(--apple-red); cursor: pointer; padding: 2px 6px;">Eliminar</button>
            </div>
          </div>
          <div style="text-align: right; padding-left: 8px;">
            <div class="price-val tabular-nums" style="font-size: 14px; font-weight: 700; color: var(--apple-text-primary);">${fmtMoney(item.price * item.quantity)}</div>
          </div>
        </div>
      `).join('');

      cartItemsContainer.innerHTML = itemsHtml;
    }

    cartItemsContainer.querySelectorAll('.btn-minus').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const id = btn.dataset.id;
        const item = cart.find(i => String(i.id) === String(id) || String(i.variantId) === String(id));
        if (item) {
          const newQty = item.quantity - 1;
          const variantId = item.variantId || parseInt(id, 10);
          if (newQty > 0) {
            item.quantity = newQty;
          } else {
            cart = cart.filter(i => String(i.id) !== String(id) && String(i.variantId) !== String(id));
          }
          saveCart();
          updateCartUI();

          if (variantId && !isNaN(variantId) && variantId > 0) {
            try {
              // Reconciliamos SIEMPRE, no solo en exito: si Shopify rechaza (sin
              // inventario) o el lock descarta el clic, changeCartLine devuelve null
              // y la cantidad optimista se quedaria mintiendo en el drawer.
              await changeCartLine({ id: String(variantId), quantity: Math.max(0, newQty) }, btn);
              await syncCartWithShopify();
            } catch (e) {
              console.warn('Shopify cart sync:', e);
            }
          }
        }
      });
    });

    cartItemsContainer.querySelectorAll('.btn-plus').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const id = btn.dataset.id;
        const item = cart.find(i => String(i.id) === String(id) || String(i.variantId) === String(id));
        if (item) {
          const newQty = item.quantity + 1;
          const variantId = item.variantId || parseInt(id, 10);
          item.quantity = newQty;
          saveCart();
          updateCartUI();

          if (variantId && !isNaN(variantId) && variantId > 0) {
            try {
              // Ver nota en el handler de "−": la reconciliacion va siempre.
              await changeCartLine({ id: String(variantId), quantity: newQty }, btn);
              await syncCartWithShopify();
            } catch (e) {
              console.warn('Shopify cart sync:', e);
            }
          }
        }
      });
    });

    cartItemsContainer.querySelectorAll('.btn-cart-delete').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        const id = btn.dataset.id;
        const item = cart.find(i => String(i.id) === String(id) || String(i.variantId) === String(id));
        const variantId = item?.variantId || parseInt(id, 10);

        // 1. Optimistic removal: remove immediately from UI & localStorage
        cart = cart.filter(i => String(i.id) !== String(id) && String(i.variantId) !== String(id));
        saveCart();
        updateCartUI();

        // 2. Synchronize removal with Shopify backend
        if (variantId && !isNaN(variantId) && variantId > 0) {
          try {
            // Ver nota en el handler de "−": la reconciliacion va siempre. Un borrado
            // que Shopify no aplico no puede quedar borrado solo en el drawer.
            await changeCartLine({ id: String(variantId), quantity: 0 }, btn);
            await syncCartWithShopify();
          } catch (e) {
            console.warn('Shopify cart delete notice:', e);
          }
        }
      });
    });

    const subtotal = cart.reduce((sum, item) => sum + (item.price * item.quantity), 0);
    const originalTotal = cart.reduce((sum, item) => sum + ((item.originalPrice || item.price) * item.quantity), 0);
    const savings = Math.max(0, originalTotal - subtotal);
    const totalCount = cart.reduce((sum, item) => sum + item.quantity, 0);

    if (cartSubtotalElem) cartSubtotalElem.textContent = fmtMoney(subtotal);
    if (cartSavingsElem) cartSavingsElem.textContent = fmtMoney(savings);
    if (cartBadgeElem) {
      cartBadgeElem.textContent = totalCount;
      cartBadgeElem.style.display = totalCount > 0 ? 'flex' : 'none';
    }

    const meterBar = document.getElementById('shipping-meter-bar') || shippingBarFill;
    const meterText = document.getElementById('shipping-meter-text') || shippingText;
    const meterPercent = document.getElementById('shipping-meter-percent');
    const freeThreshold = FREE_SHIPPING_THRESHOLD;

    if (meterBar && meterText) {
      const remaining = freeThreshold - subtotal;
      if (remaining <= 0) {
        meterText.innerHTML = `¡Felicidades! Tienes <strong>Envío Gratis</strong> en tu orden`;
        meterBar.style.width = '100%';
        if (meterPercent) meterPercent.textContent = '100%';
      } else {
        const pct = Math.min(100, Math.max(5, Math.round((subtotal / freeThreshold) * 100)));
        meterText.innerHTML = `Te faltan <strong>$${remaining.toLocaleString('es-MX')} MXN</strong> para <strong>Envío Gratis</strong>`;
        meterBar.style.width = `${pct}%`;
        if (meterPercent) meterPercent.textContent = `${pct}%`;
      }
    }

    syncUpsellsWithCart();
  }

  // Upsells complementarios (snippets/upsell-picks.liquid).
  // El bloque se pinta en Liquid con el carrito que habia al CARGAR la pagina, pero
  // despues se agregan cosas por AJAX sin recargar: sin esto, el cajon terminaria
  // ofreciendo justo el producto que el cliente acaba de meter. Se esconde la tarjeta
  // duplicada, y el bloque entero cuando ya no queda nada que ofrecer.
  function syncUpsellsWithCart() {
    const blocks = document.querySelectorAll('[data-upsell-block]');
    if (!blocks.length) return;

    const inCart = new Set();
    cart.forEach(item => {
      if (item.variantId) inCart.add(String(item.variantId));
      if (item.id) inCart.add(String(item.id));
    });

    blocks.forEach(block => {
      let visible = 0;
      block.querySelectorAll('.beluga-upsell-card').forEach(card => {
        const btn = card.querySelector('.btn-card-add-cart');
        const vid = btn ? String(btn.dataset.variantId || btn.dataset.id || '') : '';
        const duplicate = Boolean(vid) && inCart.has(vid);
        card.hidden = duplicate;
        if (!duplicate) visible += 1;
      });
      block.hidden = visible === 0;
    });
  }

  function startCartUrgencyTimer() {
    // El tema Shopify no tiene #cart-timer-digits: sin esta guarda corria un
    // setInterval cada segundo, en todas las paginas, escribiendo en la nada.
    if (!cartTimerElem) return;
    let timeLeft = 590;
    setInterval(() => {
      if (timeLeft > 0) timeLeft--;
      const minutes = Math.floor(timeLeft / 60);
      const seconds = timeLeft % 60;
      const formatted = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      if (cartTimerElem) cartTimerElem.textContent = formatted;
    }, 1000);
  }

  // Steppers de la pagina /cart. Usan `line` (indice 1-based) en vez del variant id:
  // es lo unico inequivoco cuando el mismo producto aparece en dos lineas distintas.
  // Antes estos controles eran <a href="/cart/change?...">: peticiones GET que mutaban
  // el carrito, asi que un prefetcher del navegador podia vaciar la bolsa sin clic.
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.js-cart-qty');
    if (!btn) return;
    e.preventDefault();

    const line = parseInt(btn.dataset.line, 10);
    const qty  = parseInt(btn.dataset.qty, 10);
    if (isNaN(line) || isNaN(qty)) return;

    const result = await changeCartLine({ line: line, quantity: Math.max(0, qty) }, btn);
    if (result) window.location.reload();
  });

  // Global Add to Cart click delegation (works for server-rendered Liquid cards and dynamic JS cards)
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.btn-card-add-cart, .btn-quick-add');
    if (!btn) return;
    
    // If inside a form, let form handle or intercept cleanly
    e.preventDefault();
    e.stopPropagation();

    const card = btn.closest('.apple-product-card');
    const variantId = btn.dataset.variantId || btn.dataset.id;
    const handle = btn.dataset.handle || (String(btn.dataset.url || (card?.querySelector('a')?.getAttribute('href')) || '').match(/\/products\/([^/?#]+)/) || [])[1] || '';
    const url = btn.dataset.url || card?.querySelector('a')?.getAttribute('href') || (handle ? `/products/${handle}` : '');
    const title = btn.dataset.title || card?.querySelector('.apple-card-title a, .apple-card-name a')?.textContent?.trim() || 'Suplemento';
    const price = parseFloat(btn.dataset.price) || 0;
    const originalPrice = parseFloat(btn.dataset.originalPrice || btn.dataset.price) || price;
    const brand = btn.dataset.brand || card?.querySelector('.apple-card-brand, .apple-card-tag')?.textContent?.trim() || 'BELUGA FITNESS';
    const image = btn.dataset.image || card?.querySelector('img')?.src || '';

    btn.classList.add('added');
    const origText = btn.textContent;
    btn.textContent = '✓ Agregado';
    setTimeout(() => {
      btn.classList.remove('added');
      btn.textContent = origText;
    }, 1200);

    await addToCart({
      id: variantId || handle || title,
      variantId: variantId,
      handle: handle,
      url: url,
      name: title,
      title: title,
      price: price,
      originalPrice: originalPrice,
      brand: brand,
      image: image,
      quantity: 1
    });
  });

  // Global Delegated Click Handler for Drawers & Modals (guarantees closing across all pages)
  document.addEventListener('click', (e) => {
    // 1. Cart Drawer Close Button
    const closeCartBtnEl = e.target.closest('#btn-close-cart, .btn-close-cart, [data-close-cart], [aria-label="Cerrar Bolsa"], [aria-label="Cerrar bolsa"]');
    if (closeCartBtnEl) {
      e.preventDefault();
      closeCart();
      return;
    }

    // 2. Cart Drawer Overlay Backdrop
    const cartOverlayEl = document.getElementById('cart-drawer-overlay');
    if (cartOverlayEl && cartOverlayEl.classList.contains('active') && e.target === cartOverlayEl) {
      e.preventDefault();
      closeCart();
      return;
    }

    // 3. Cart Trigger Button (open)
    const cartTriggerEl = e.target.closest('#btn-cart-toggle, .apple-cart-trigger, [data-open-cart]');
    if (cartTriggerEl && !cartTriggerEl.closest('#cart-drawer-overlay')) {
      e.preventDefault();
      openCart();
      return;
    }

    // 4. Brands Directory Modal Close Button
    const closeBrandsBtnEl = e.target.closest('#btn-close-brands-modal, .btn-close-brands, [data-close-brands], [aria-label="Cerrar directorio"]');
    if (closeBrandsBtnEl) {
      e.preventDefault();
      closeBrandsModal();
      return;
    }

    // 5. Brands Directory Overlay Backdrop
    const brandsOverlayEl = document.getElementById('brands-modal-overlay');
    if (brandsOverlayEl && brandsOverlayEl.classList.contains('active') && e.target === brandsOverlayEl) {
      e.preventDefault();
      closeBrandsModal();
      return;
    }
  });

  // Global ESC Key Listener for All Overlays
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' || e.key === 'Esc') {
      closeCart();
      closeBrandsModal();
    }
  });

  // Expose global helper interface for theme interoperability
  window.BelugaCart = {
    open: openCart,
    close: closeCart,
    add: addToCart,
    sync: syncCartWithShopify,
    getCart: () => cart
  };
  window.openCart = openCart;
  window.closeCart = closeCart;

  // Run on DOM Ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
